import React, { useEffect, useState, useRef } from "react";
import "./dashboard.scss";
import DataTable from "./DataTable/DataTable";
import axios from "axios";
import { Api_Url } from "../../../utils/ApiUrl";
import Modal from "react-bootstrap/Modal";
// import axios from 'axios';
// import { Api_Url } from '../../../utils/ApiUrl';
import { useHistory } from "react-router-dom";
import Web3 from "web3";
import { toast } from "react-toastify";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css";
import { DateRange } from "react-date-range";
import { useDetectClickOutside } from "react-detect-click-outside";
import { CopyToClipboard } from "react-copy-to-clipboard";
import CurrentRound from "../../../hooks/dataFetchers/round";
import tableup from "../../../assets/tableup.svg";
import tabledown from "../../../assets/tabledown.svg";
import { useDispatch } from "react-redux";
import { goldenUsers } from "../../../redux/action";
import moment from "moment";
import Countrychart from "./CountryChart";
import { PROJECT_MAPPING, projectPercentage } from '../../../utils/Constants'
import useAdminAllowed from "../../../hooks/userManagement/useAdminAllowed";
const Dashboard = ({
  user,
  setUser,
  tomiPrice,
  usdPrice,
  btcPrice,
  pepePrice,
  linkPrice,
  uniPrice,
  dopPrice,
  gemsPrice,
  hitfunctionss,
}) => {
  let userRole = user?.role;
  // console.log(usdPrice, 'useruseruser')
  const dispatch = useDispatch();
  const [project, setProject] = useState(PROJECT_MAPPING[0]?.value);

  const [topThreeApiCalled, setTopThreeApiCalled] = useState(false);

  const [topTenApiCalled, setTopTenApiCalled] = useState(false);
  const [transactionApiCalled, setTransactionApiCalled] = useState(false);
  const { currentRound } = CurrentRound();
  const [totalRound, setTotalRound] = useState([]);

  const [codeDataCall, setCodeDataCall] = useState();
  const tok = localStorage?.getItem("accessToken");
  const [data, setData] = useState([]);
  const [totalT, setTotalT] = useState(0);
  const [welcome, setwelcome] = useState();
  const [purchases, setPurchases] = useState(null);
  const [earnings, setEarnings] = useState(null);
  const [netRevenue, setnetRevenue] = useState(null);
  // const [usdPrice, setUsdPrice] = useState(0);
  // // console.log("sdfdsfsdf", usdPrice)
  // const [tomiPrice, setchange24hr1] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [specialAccess, setSpecialAccess] = useState([]);
  const [myTree, setMyTree] = useState([]);
  const [otherLeaders, setOtherLeaders] = useState([]);
  const [otherLeadersEarnings, setOtherLeadersEarnings] = useState([]);
  const [myTreePurchasedAmount, setMyTreePurchasedAmount] = useState([]);
  const checkAdminPermission = useAdminAllowed();
  const [otherLeadersPurchasedAmount, setOtherLeadersPurchasedAmount] =
    useState([]);

  const [userselectdate, setuserselectdate] = useState(false);
  const [pc, setPC] = useState(0);
  const [pmc, setPMC] = useState(0);
  const [nrc, setNRC] = useState(0);
  const [lc, setLC] = useState(0);
  const [dpc, setDPC] = useState(0);
  const [lec, setLEC] = useState(0);
  const [a, seta] = useState(0);
  const [m, setm] = useState(0);
  const [s, sets] = useState(0);
  const [g, setg] = useState(0);
  const [gmini, setgmini] = useState(0);
  const [selectedItem, setSelectedItem] = useState({
    imgSrc: PROJECT_MAPPING[0]?.imageSrc,
    text: PROJECT_MAPPING[0]?.value,
    rounds: PROJECT_MAPPING[0]?.rounds
  });
  const [mm, setmm] = useState(0);
  const [ss, setss] = useState(0);
  const [gg, setgg] = useState(0);
  const [ggmini, setggmini] = useState(0);

  const [purchasesAndEarnings, setPurchasedAndEarnings] = useState(0);

  const [pee, setPEE] = useState(0);
  const [peu, setPEU] = useState(0);
  const [pet, setPET] = useState(0);

  const [totPurchases, setTotPurchases] = useState(0);
  const [dopPurchased, setDOPPurchased] = useState(0);

  const [ind, setIND] = useState(0);
  const [dt, setDT] = useState(0);
  const [totalleader, settotalleader] = useState(0);
  const [activeleader, setactiveleader] = useState(0);
  const [round, setRound] = useState("");

  const [dops, setDops] = useState(null);
  // const [dopPrice, setDopPrice] = useState(0);
  const [search, setSearch] = useState("");
  const [topLeaderSearch, setTopLeaderSearch] = useState("");

  const [dataTime, setDataTime] = useState("1");
  const [dataTimeTop, setDataTimeTop] = useState("1");
  const [showtext, SetShowtext] = useState(false);

  const [orderField, setOrderField] = useState("transactionTime");
  const [orderDirection, setOrderDirection] = useState("-1");
  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState([]);
  const [topTenLeaders, setTopTenLeaders] = useState([]);
  const [topTenData, setTopTenData] = useState([]);
  const [topThreeData, setTopThreeData] = useState([]);
  const [topThreeLeadersData, setTopThreeLeadersData] = useState([]);
  const [chartsData, setChartsData] = useState();

  const [tokenNftStats, setTokenNftStats] = useState();
  // const [tomiPrice, setTomiPrice] = useState("");
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: null,
      key: "selection",
    },
  ]);

  const [showcalendar, setShowCalendar] = useState(false);

  const [Users1, setUsers1] = useState(null);
  const [Users2, setUsers2] = useState(null);
  const [Users3, setUsers3] = useState(null);
  const [Users4, setUsers4] = useState(null);

  const history = useHistory();

  const [loader, setLoader] = useState(false);
  const [alllset, setalllset] = useState("1");
  const [show, setShow] = useState(false);
  const [agents, setAgents] = useState([]);
  const [name, setName] = useState("");
  const [role, setRole] = useState(null);
  const [addr, setAddr] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => {
    setName("");
    setAddr("");
    setEmail("");
    // setRole(null);
    setShow1(false);
  };

  const [activeTab, setActiveTab] = useState("home-tab");

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => {
    setShow2(false);
    setRole(null);
  };
  function isValidEmail(email) {
    var pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return pattern.test(email);
  }

  function isAddressValid(address) {
    return Web3.utils.isAddress(address);
  }

  // const getTomiPrice = async () => {
  //   try {
  //     const response = await axios.get(
  //       `https://api.coingecko.com/api/v3/simple/price`,
  //       {
  //         params: {
  //           ids: "tomiNet",
  //           vs_currencies: "usd",
  //         },
  //       }
  //     );

  //     const data = response?.data;
  //     const priceInUSD = data["tominet"]?.usd;

  //     setTomiPrice(priceInUSD);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     // throw error;
  //   }
  // };

  useEffect(() => {
    if (activeTab == "profile-tab" && user?.role != "mini_agent") {
      GetTopTenLeaders();
    } else if (activeTab == "top-ten" || activeTab == "special-access") {
      GetTopTenData();
    } else if (user?.role == "admin" && activeTab == "top-three") {
      GetTopThreeData();
    } else if (userRole != "admin" && userRole != undefined) {
      GetTopThreeData();
    }
  }, [
    activeTab,
    topLeaderSearch,
    dataTime,
    dataTimeTop,
    round,
    userRole,
    project,
  ]);

  const GetTopThreeData = async () => {
    // if (account) {
    setTopThreeData([]);

    let time;
    if (dataTime && user?.role == "admin") {
      time = dataTime;
    } else if (dataTimeTop && user?.role != "admin") {
      time = dataTimeTop;
    }
    let date = null;
    let date1 = null;
    if (time == "1") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 0; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");

      //////////////////////////////////////////
      // var date12 = new Date();

      // var dateOffset = 24 * 60 * 60 * 1000; // 24 hours (1 day) in milliseconds
      // var myDate = new Date(date12.getTime() - dateOffset); // Subtract 24 hours from the current time

      // date = myDate.toISOString(); // Start time (24 hours ago)
      // date1 = date12.toISOString(); // Current time as end time
    } else if (time == "seven") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 7; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (time == "year") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 365; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (time == "month") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 31; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    }

    let url = "";
    if (user?.role === "admin" && activeTab == "top-three") {
      url = `${Api_Url}/users/top-three?limit=3&privateSale=${project}`;
      // remove the private sale url from here

      if (url != null) {
        let dynamicQuery = url;

        if (time) {
          dynamicQuery += `&startDate=${date}&endDate=${date1}`;
        }
        if (round) {
          dynamicQuery += `&round=${round}`;
        }

        url = dynamicQuery;
        var config = {
          method: "get",
          url: url,
          headers: {
            authorization: `Bearer ` + tok,
          },
        };

        axios(config)
          .then(function (response) {
            setTopThreeData(response?.data?.data);
            setTopThreeApiCalled(true);
          })
          .catch(function (error) {
            setTopThreeApiCalled(true);

            // console.log(error);
          });
      }
    } else if (userRole != "admin") {
      url = `${Api_Url}/users/top-three?limit=3&privateSale=${project}`;
      // remove the private sale url from here

      if (url != null) {
        let dynamicQuery = url;

        if (time) {
          dynamicQuery += `&startDate=${date}&endDate=${date1}`;
        }
        if (round) {
          dynamicQuery += `&round=${round}`;
        }

        url = dynamicQuery;
        var config = {
          method: "get",
          url: url,
          headers: {
            authorization: `Bearer ` + tok,
          },
        };

        axios(config)
          .then(function (response) {
            setTopThreeLeadersData(response?.data?.data);
            setTopThreeApiCalled(true);
          })
          .catch(function (error) {
            setTopThreeApiCalled(true);

            // console.log(error);
          });
      }
    }

    // }
  };

  const GetTopThreeData1 = async (times) => {
    // if (account) {
    setTopThreeData([]);
    setalllset();
    setuserselectdate(true);
    setState(times);
    let date = null;
    let date1 = null;
    if (times) {
      let a = new Date(times[0]?.startDate);
      let b = new Date(times[0]?.endDate);
      date = moment(a).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(b).utc().format("Y-MM-DDT23:59:59");
    }

    if (date && date1) {
      let url = "";
      if (user?.role === "admin" && activeTab == "top-three") {
        url = `${Api_Url}/users/top-three?limit=3&privateSale=${project}`;
        // remove the private sale url from here

        if (url != null) {
          let dynamicQuery = url;

          dynamicQuery += `&startDate=${date}&endDate=${date1}`;
          if (round) {
            dynamicQuery += `&round=${round}`;
          }

          url = dynamicQuery;
          var config = {
            method: "get",
            url: url,
            headers: {
              authorization: `Bearer ` + tok,
            },
          };

          axios(config)
            .then(function (response) {
              setTopThreeData(response?.data?.data);

              setTopThreeApiCalled(true);
            })
            .catch(function (error) {
              setTopThreeApiCalled(true);

              // console.log(error);
            });
        }
      } else if (user?.role != "admin") {
        url = `${Api_Url}/users/top-three?limit=3&privateSale=${project}`;
        // remove the private sale url from here

        if (url != null) {
          let dynamicQuery = url;

          dynamicQuery += `&startDate=${date}&endDate=${date1}`;
          if (round) {
            dynamicQuery += `&round=${round}`;
          }

          url = dynamicQuery;
          var config = {
            method: "get",
            url: url,
            headers: {
              authorization: `Bearer ` + tok,
            },
          };

          axios(config)
            .then(function (response) {
              setTopThreeLeadersData(response?.data?.data);

              setTopThreeApiCalled(true);
            })
            .catch(function (error) {
              setTopThreeApiCalled(true);

              // console.log(error);
            });
        }
      }
    }
    // }
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////
  const GetTopTenData = async () => {
    // if (account) {
    setTopTenData([]);

    let time;
    if (dataTime && user?.role == "admin") {
      time = dataTime;
    } else if (dataTimeTop && user?.role != "admin") {
      time = dataTimeTop;
    }
    let date = null;
    let date1 = null;
    if (time == "1") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 0; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");

      //////////////////////////////////////////
      // var date12 = new Date();

      // var dateOffset = 24 * 60 * 60 * 1000; // 24 hours (1 day) in milliseconds
      // var myDate = new Date(date12.getTime() - dateOffset); // Subtract 24 hours from the current time

      // date = myDate.toISOString(); // Start time (24 hours ago)
      // date1 = date12.toISOString(); // Current time as end time
    } else if (time == "seven") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 7; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (time == "year") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 365; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (time == "month") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 31; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    }

    let url = null;
    if (user?.role === "admin" && activeTab == "top-ten") {
      url = `${Api_Url}/users/top-ten?limit=10&privateSale=${project}`;
    } else if (
      user?.role == "god_agent" &&
      user?.specialAccess &&
      user?.specialAccess?.length > 0 &&
      activeTab == "special-access"
    ) {
      url = `${Api_Url}/users/god-special-accesses?limit=10&offset=1&privateSale=${project}`;
    }
    if (url != null) {
      let dynamicQuery = url;

      if (topLeaderSearch) {
        dynamicQuery += `&search=${topLeaderSearch}`;
      }

      if (time) {
        dynamicQuery += `&startDate=${date}&endDate=${date1}`;
      }
      if (round) {
        dynamicQuery += `&round=${round}`;
      }

      url = dynamicQuery;
      var config = {
        method: "get",
        url: url,
        headers: {
          authorization: `Bearer ` + tok,
        },
      };

      axios(config)
        .then(function (response) {
          if (user?.role === "admin" && activeTab == "top-ten") {
            setTopTenData(response?.data?.data);
          } else if (
            user?.role == "god_agent" &&
            user?.specialAccess &&
            user?.specialAccess?.length > 0 &&
            activeTab == "special-access"
          ) {
            setTopTenData(response?.data?.data?.specialAccesses);
          }

          setTopTenApiCalled(true);
        })
        .catch(function (error) {
          setTopTenApiCalled(true);

          // console.log(error);
        });
    }
    // }
  };

  const GetTopTenData1 = async (times) => {
    // if (account) {
    setTopTenData([]);
    setalllset();
    setuserselectdate(true);
    setState(times);
    let date = null;
    let date1 = null;
    if (times) {
      let a = new Date(times[0]?.startDate);
      let b = new Date(times[0]?.endDate);
      date = moment(a).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(b).utc().format("Y-MM-DDT23:59:59");
    }

    if (date && date1) {
      let url = null;
      if (user?.role === "admin" && activeTab == "top-ten") {
        url = `${Api_Url}/users/top-ten?limit=10&privateSale=${project}`;
      } else if (
        user?.role == "god_agent" &&
        user?.specialAccess &&
        user?.specialAccess?.length > 0 &&
        activeTab == "special-access"
      ) {
        url = `${Api_Url}/users/god-special-accesses?limit=10&offset=1&privateSale=${project}`;
      }
      if (url != null) {
        let dynamicQuery = url;

        if (topLeaderSearch) {
          dynamicQuery += `&search=${topLeaderSearch}`;
        }

        dynamicQuery += `&startDate=${date}&endDate=${date1}`;
        if (round) {
          dynamicQuery += `&round=${round}`;
        }

        url = dynamicQuery;
        var config = {
          method: "get",
          url: url,
          headers: {
            authorization: `Bearer ` + tok,
          },
        };

        axios(config)
          .then(function (response) {
            if (user?.role === "admin" && activeTab == "top-ten") {
              setTopTenData(response?.data?.data);
            } else if (
              user?.role == "god_agent" &&
              user?.specialAccess &&
              user?.specialAccess?.length > 0 &&
              activeTab == "special-access"
            ) {
              setTopTenData(response?.data?.data?.specialAccesses);
            }

            setTopTenApiCalled(true);
          })
          .catch(function (error) {
            setTopTenApiCalled(true);

            // console.log(error);
          });
      }
    }
    // }
  };

  ///////////////////////////////////////////////////////////////////////////////////
  const GetTopTenLeaders = async () => {
    // if (account) {
    let time;
    if (dataTime && user?.role == "admin") {
      time = dataTime;
    } else if (dataTimeTop && user?.role != "admin") {
      time = dataTimeTop;
    }
    let date = null;
    let date1 = null;
    if (time == "1") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 0; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");

      //////////////////////////////////////////
      // var date12 = new Date();

      // var dateOffset = 24 * 60 * 60 * 1000; // 24 hours (1 day) in milliseconds
      // var myDate = new Date(date12.getTime() - dateOffset); // Subtract 24 hours from the current time

      // date = myDate.toISOString(); // Start time (24 hours ago)
      // date1 = date12.toISOString(); // Current time as end time
    } else if (time == "seven") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 7; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (time == "year") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 365; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (time == "month") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 31; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    }

    let url = null;
    if (user?.role === "admin") {
      url = `${Api_Url}/users/top-leaders?limit=10&privateSale=${project}`;
    } else if (user?.role === "god_agent") {
      url = `${Api_Url}/users/god-top-leaders?limit=10&privateSale=${project}`;
    } else if (
      user?.role === "mega_agent" ||
      user?.role === "super_agent" ||
      user?.role === "agent"
    ) {
      url = `${Api_Url}/users/mega-super-top-leaders?limit=10&privateSale=${project}`;
    }
    if (url != null) {
      let dynamicQuery = url;

      if (topLeaderSearch) {
        dynamicQuery += `&search=${topLeaderSearch}`;
      }

      if (time) {
        dynamicQuery += `&startDate=${date}&endDate=${date1}`;
      }
      if (round) {
        dynamicQuery += `&round=${round}`;
      }

      url = dynamicQuery;
      var config = {
        method: "get",
        url: url,
        headers: {
          authorization: `Bearer ` + tok,
        },
      };

      axios(config)
        .then(function (response) {
          setTopTenLeaders(response?.data?.data);
          setTopTenApiCalled(true);
        })
        .catch(function (error) {
          setTopTenApiCalled(true);

          // console.log(error);
        });
    }
    // }
  };

  const GetTopTenLeaders1 = async (times) => {
    // if (account) {
    setalllset();
    setuserselectdate(true);
    setState(times);
    let date = null;
    let date1 = null;
    if (times) {
      let a = new Date(times[0]?.startDate);
      let b = new Date(times[0]?.endDate);
      date = moment(a).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(b).utc().format("Y-MM-DDT23:59:59");
    }

    if (date && date1) {
      let url = null;
      if (user?.role === "admin") {
        url = `${Api_Url}/users/top-leaders?limit=10&privateSale=${project}`;
      } else if (user?.role === "god_agent") {
        url = `${Api_Url}/users/god-top-leaders?limit=10&privateSale=${project}`;
      } else if (
        user?.role === "mega_agent" ||
        user?.role === "super_agent" ||
        user?.role === "agent"
      ) {
        url = `${Api_Url}/users/mega-super-top-leaders?limit=10&privateSale=${project}`;
      }
      if (url != null) {
        let dynamicQuery = url;

        if (topLeaderSearch) {
          dynamicQuery += `&search=${topLeaderSearch}`;
        }
        dynamicQuery += `&startDate=${date}&endDate=${date1}`;

        if (round) {
          dynamicQuery += `&round=${round}`;
        }

        url = dynamicQuery;
        var config = {
          method: "get",
          url: url,
          headers: {
            authorization: `Bearer ` + tok,
          },
        };

        axios(config)
          .then(function (response) {
            setTopTenLeaders(response?.data?.data);
            setTopTenApiCalled(true);
          })
          .catch(function (error) {
            setTopTenApiCalled(true);

            // console.log(error);
          });
      }
    }
    // }
  };

  const AddAgent = async () => {
    // await checkAdminPermission();
    const lowerCaseEmail = email.toLowerCase();
    const val = localStorage.getItem("accessToken");
    let url = null;
    if (user?.role === "admin") {
      url = `${Api_Url}/users/god-agents`;
    } else if (role === "mega_agent") {
      url = `${Api_Url}/users/mega-agents`;
    } else if (role === "super_agent") {
      url = `${Api_Url}/users/super-agents`;
    } else if (role === "agent") {
      url = `${Api_Url}/users/agents`;
    } else if (role === "mini_agent") {
      url = `${Api_Url}/users/mini-agents`;
    }
    if (name?.length > 2) {
      if (isAddressValid(addr)) {
        if (isValidEmail(email)) {
          setLoader(true);
          var config = {
            method: "post",
            url: url,
            data: {
              name: name,
              walletAddress: addr,
              email: lowerCaseEmail,
              name: name,
            },
            headers: {
              Authorization: "Bearer " + val,
            },
          };
          axios(config)
            .then(function (response) {
              setLoader(false);
              GetMyData();
              setName("");
              setAddr("");
              setEmail("");
              // setRole(null);
              handleClose1();
              setShow2(true);
            })
            .catch(function (error) {
              setLoader(false);
              setRole(null);

              toast.error(error?.response?.data?.message);
              if (error?.response?.status == 401) {
                // localStorage.removeItem("accessToken");
                // history.push("/");
              }
            });
        } else {
          setError("Incorrect Email!");
        }
      } else {
        setError("Incorrect wallet address!");
      }
    } else {
      setError("Name must be of length 3!");
    }
  };

  function convertToTitleCase(input) {
    if (input) {
      let words = input
        .split("_")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      if (words[0] === "mini" || words[0] === "Mini") {
        return "Ambassador";
      }
      if (
        words[words.length - 1].toLowerCase() === "agent" &&
        (words[0] != "mini" || words[0] != "Mini")
      ) {
        words[words.length - 1] = "Leader";
      }
      if (words[0] === "super" || words[0] === "Super") {
        return "Super";
      } else if (words[0] !== "agent") {
        return words.join(" ");
      } else {
        return "Leader";
      }
    } else {
      return "";
    }
  }

  const handlePageChange = (e) => {
    const selectedPage = e.selected;

    setPage(selectedPage);
  };

  const getTransactionsData = () => {
    var config = {
      method: "get",
      url: `${Api_Url}/users/all-transactions?privateSale=${project}&limit=20&offset=1`,
      // remove the private sale url from here

      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    let dynamicQuery = config.url;

    if (search) {
      dynamicQuery += `&by=${search}`;
    }

    if (orderField) {
      dynamicQuery += `&orderField=${orderField}&orderDirection=${orderDirection}`;
    }
    if (user?.role == "god_agent") {
      dynamicQuery += `&myTree=true`;
    }
    if (round) {
      dynamicQuery += `&round=${round}`;
    }

    config.url = dynamicQuery;

    axios(config)
      .then(function (res) {
        // // console.log("trx data: ", res?.data?.data?.transactions);
        setTransactions(res?.data?.data?.transactions);
        setPageCount(res?.data?.data?.pages);
        setTransactionApiCalled(true);
        setLoader(false);
      })
      .catch(function (error) {
        setTransactionApiCalled(true);

        setLoader(false);
      });
  };

  const [adminobj, setadminobj] = useState();

  useEffect(() => {
    // GetAllRounds();
    // GetMyData();
    if (usdPrice && user) {
      getTransactionsData();
      // getTotalList();
    }
  }, [usdPrice, user, search, orderField, orderDirection, round, project]);

  useEffect(() => {
    if (usdPrice) {
      if (user?.role == "admin") {
        setwelcome("Admin");
        // GetDashboardData1();
        // GetChartsData();
      }
    }
  }, [user]);

  const GetChartsDataCalendar = () => {
    // setalllset();
    // setState(times);
    // let date = null;
    // let date1 = null;
    // if (times) {
    //   let a = new Date(times[0]?.startDate);
    //   let b = new Date(times[0]?.endDate);
    //   date = moment(a).utc().format("Y-MM-DDT00:00:00");
    //   date1 = moment(b).utc().format("Y-MM-DDT23:59:59");
    // }

    var config = {
      method: "get",
      url: `${Api_Url}/emails/country/stats?privateSale=${project}&limit=30`,
      // url: `${Api_Url}/users/leader-counts?startDate=${stDate}&&endDate=${enDate}`,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };

    let dynamicQuery = config.url;

    if (startDate && startDate != null) {
      dynamicQuery += `&startDate=${startDate}&endDate=${endDate}`;
    }
    // if (round) {
    //   dynamicQuery += `&round=${round}`;
    // }

    config.url = dynamicQuery;

    axios(config)
      .then(function (response) {
        let resData = response?.data?.data;
        setChartsData(resData);
      })
      .catch(function (error) {
        // console.log(error);
      });
  };

  // Admin data upper stats
  const GetDashboardData = () => {
    var config = {
      method: "get",
      url: `${Api_Url}/users/superadmin/stats?privateSale=${project}`,
      // url: `${Api_Url}/users/leader-counts?startDate=${stDate}&&endDate=${enDate}`,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };

    let dynamicQuery = config.url;

    if (startDate && startDate != null) {
      dynamicQuery += `&startDate=${startDate}&endDate=${endDate}`;
    }
    if (round) {
      dynamicQuery += `&round=${round}`;
    }

    config.url = dynamicQuery;

    axios(config)
      .then(function (response) {
        if (response?.data?.data?.stats?.length > 0) {
          setadminobj(response?.data?.data?.stats[0]);
        } else {
          setadminobj();
        }
        let value = response?.data?.data;
        settotalleader(
          value?.agents +
          value?.godAgents +
          value?.megaAgents +
          value?.superAgents +
          value?.miniAgents
        );
        setactiveleader(value?.activeLeaders);
        setTokenNftStats(value);
        // if (times) {
        let purchaseChange = value?.oldleadersStats
          ? ((value?.stats[0]?.TotalPurchases -
            value?.oldleadersStats[0]?.TotalPurchases) /
            value?.oldleadersStats[0]?.TotalPurchases) *
          100
          : 0;
        setPC(purchaseChange);

        let newPurchasedAmount =
          value?.stats[0]?.totalPurchaseEth * usdPrice +
          value?.stats[0]?.totalPurchaseUsdt;
        let oldPurchasedAmount = value?.oldleadersStats
          ? value?.oldleadersStats[0]?.totalPurchaseEth * usdPrice +
          value?.oldleadersStats[0]?.totalPurchaseUsdt
          : 0;

        let purchasedAmountChange = 0;

        if (newPurchasedAmount === 0 && oldPurchasedAmount === 0) {
          purchasedAmountChange = 0;
        } else if (newPurchasedAmount === 0 || oldPurchasedAmount === 0) {
          if (newPurchasedAmount === 0) {
            purchasedAmountChange =
              ((0 - oldPurchasedAmount) / oldPurchasedAmount) * 100;
          }
          if (oldPurchasedAmount === 0) {
            purchasedAmountChange = ((newPurchasedAmount + 1 - 1) / 1) * 100;
          }
        } else {
          purchasedAmountChange =
            ((newPurchasedAmount - oldPurchasedAmount) / oldPurchasedAmount) *
            100;
        }

        setPMC(purchasedAmountChange);

        setNRC(value?.netRevenueChange);

        let newLeadersCount =
          value?.agents +
          value?.godAgents +
          value?.megaAgents +
          value?.superAgents +
          value?.miniAgents;
        let oldLeadersCount =
          value?.oldleaders +
          value?.oldgodLeaders +
          value?.oldmegaLeaders +
          value?.oldsuperLeaders +
          value?.oldminiLeaders;
        let leadersChange = 0;
        if (newLeadersCount === 0 && oldLeadersCount === 0) {
          leadersChange = 0;
        } else if (newLeadersCount === 0 || oldLeadersCount === 0) {
          if (newLeadersCount === 0) {
            leadersChange = ((0 - oldLeadersCount) / oldLeadersCount) * 100;
          }
          if (oldLeadersCount === 0) {
            leadersChange = ((newLeadersCount + 1 - 1) / 1) * 100;
          }
        } else {
          leadersChange =
            ((newLeadersCount - oldLeadersCount) / oldLeadersCount) * 100;
        }
        setLC(leadersChange);
        let dopChange = value?.oldleadersStats
          ? ((value?.stats[0]?.totalDopPurchased -
            value?.oldleadersStats[0]?.totalDopPurchased) /
            value?.oldleadersStats[0]?.totalDopPurchased) *
          100
          : 0;
        setDPC(dopChange);

        let totalLeaderEarningsEthValueOld = value?.oldleadersStats
          ? value?.oldleadersStats[0]?.totalLeaderEarningsEth * usdPrice
          : 0;

        let totalLeaderEarningsEthValueNew =
          value?.stats[0]?.totalLeaderEarningsEth * usdPrice;

        let totalLeaderEarningsOldPrice = value?.oldleadersStats
          ? totalLeaderEarningsEthValueOld +
          value?.oldleadersStats[0]?.totalLeaderEarningsUsdt
          : 0;
        let totalLeaderEarningsNewPrice =
          totalLeaderEarningsEthValueNew +
          value?.stats[0]?.totalLeaderEarningsUsdt;

        let totalLeadersEarningChange = 0;

        if (
          totalLeaderEarningsNewPrice === 0 &&
          totalLeaderEarningsOldPrice === 0
        ) {
          totalLeadersEarningChange = 0;
        } else if (
          totalLeaderEarningsNewPrice === 0 ||
          totalLeaderEarningsOldPrice === 0
        ) {
          if (totalLeaderEarningsNewPrice === 0) {
            totalLeadersEarningChange =
              ((0 - totalLeaderEarningsOldPrice) /
                totalLeaderEarningsOldPrice) *
              100;
          }
          if (totalLeaderEarningsOldPrice === 0) {
            totalLeadersEarningChange =
              ((totalLeaderEarningsNewPrice + 1 - 1) / 1) * 100;
          }
        } else {
          totalLeadersEarningChange =
            ((totalLeaderEarningsNewPrice - totalLeaderEarningsOldPrice) /
              totalLeaderEarningsOldPrice) *
            100;
        }

        setLEC(totalLeadersEarningChange);
        // } else {
        setPC("");
        setPMC("");

        setNRC("");
        setLC("");
        setDPC("");
        setLEC("");
        // }

        seta(value?.agents);
        setg(value?.godAgents);
        setm(value?.megaAgents);
        sets(value?.superAgents);
        setgmini(value?.miniAgents);
      })
      .catch(function (error) {
        // console.log(error);
      });
  };

  const firstTimeData = async () => {
    console.log("selectedItem", selectedItem);

    // ✅ If rounds already exist in selectedItem
    if (selectedItem?.rounds?.length > 0) {
      const normalizedRounds = selectedItem.rounds.map((round) => ({
        ...round,
        round: round.roundNumber?.toString(), // 👈 normalize here
      }));

      setTotalRound(normalizedRounds);
      return;
    }

    // ❌ Otherwise call API
    try {
      const response = await axios({
        method: "get",
        url: `${Api_Url}/sale-rounds?offset=1&limit=25&privateSale=${project}`,
        headers: {
          authorization: `Bearer ${tok}`,
        },
      });

      const saleRounds = response?.data?.data?.saleRounds || [];

      const uniqueNickNameObjects = [];
      const seenNickNames = new Set();

      for (const item of saleRounds) {
        if (!seenNickNames.has(item.nickName)) {
          seenNickNames.add(item.nickName);
          uniqueNickNameObjects.push(item);
        }
      }

      setTotalRound(uniqueNickNameObjects);
    } catch (error) {
      console.log(error);
    }
  };


  const GetMyData = async () => {
    const tok = localStorage?.getItem("accessToken");
    // if (account) {
    var config = {
      method: "get",
      url: `${Api_Url}/users/my/stats?privateSale=${project}`,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };
    axios(config)
      .then(function (response) {
        setuserselectdate(false);
        let value = response?.data?.data;
        setTokenNftStats(value);

        // // console.log("sdfsfsdfsdfsdfdsfsdfdf", value);
        setSpecialAccess(value?.specialAccess);
        setMyTree(value?.myTree);
        setOtherLeaders(value?.otherLeaders);
        setOtherLeadersEarnings(value?.otherLeadersEarnings);

        setMyTreePurchasedAmount(value?.myTreePurchasedAmount);
        setOtherLeadersPurchasedAmount(value?.otherLeadersPurchasedAmount);

        setTotPurchases(value?.totalPurchases);
        setDOPPurchased(value?.totalDopPurchased);
        setPurchasedAndEarnings(value?.purchasedAndEarnings);

        setIND(value?.inDirectSales);
        setDT(value?.directSales);
        let purchasesOld =
          value?.oldPurchasesAndDopPurchased[0]?.TotalPurchases;
        let purchasesNew = value?.totalPurchases;

        let purchaseChange =
          ((purchasesNew - purchasesOld) / purchasesOld) * 100;
        setPC(purchaseChange);

        let oldPurchasedEth =
          value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
            ? value?.oldPurchasedAndEarnings[0]?.totalPurchase
            : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[1]?.totalPurchase
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "ETH"
                ? value?.oldPurchasedAndEarnings[2]?.totalPurchase
                : 0;
        let oldPurchasedUsdt =
          value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
            ? value?.oldPurchasedAndEarnings[0]?.totalPurchase
            : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[1]?.totalPurchase
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
                ? value?.oldPurchasedAndEarnings[2]?.totalPurchase
                : 0;
        let oldPurchasedTomi =
          value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
            ? value?.oldPurchasedAndEarnings[0]?.totalPurchase
            : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[1]?.totalPurchase
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
                ? value?.oldPurchasedAndEarnings[2]?.totalPurchase
                : 0;

        let newPurchasedEth =
          value?.purchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
            ? value?.purchasedAndEarnings[0]?.totalPurchase
            : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
              ? value?.purchasedAndEarnings[1]?.totalPurchase
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "EETH"
                ? value?.purchasedAndEarnings[2]?.totalPurchase
                : 0;
        let newPurchasedUsdt =
          value?.purchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
            ? value?.purchasedAndEarnings[0]?.totalPurchase
            : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[1]?.totalPurchase
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
                ? value?.purchasedAndEarnings[2]?.totalPurchase
                : 0;
        let newPurchasedTomi =
          value?.purchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
            ? value?.purchasedAndEarnings[0]?.totalPurchase
            : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[1]?.totalPurchase
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
                ? value?.purchasedAndEarnings[2]?.totalPurchase
                : 0;
        let newPurchasedAmount = newPurchasedEth * usdPrice + newPurchasedUsdt;
        let oldPurchasedAmount = oldPurchasedEth * usdPrice + oldPurchasedUsdt;

        let purchasedAmountChange = 0;

        if (newPurchasedAmount === 0 && oldPurchasedAmount === 0) {
          purchasedAmountChange = 0;
        } else if (newPurchasedAmount === 0 || oldPurchasedAmount === 0) {
          if (newPurchasedAmount === 0) {
            purchasedAmountChange =
              ((0 - oldPurchasedAmount) / oldPurchasedAmount) * 100;
          }
          if (oldPurchasedAmount === 0) {
            purchasedAmountChange = ((newPurchasedAmount + 1 - 1) / 1) * 100;
          }
        } else {
          purchasedAmountChange =
            ((newPurchasedAmount - oldPurchasedAmount) / oldPurchasedAmount) *
            100;
        }

        setPMC(purchasedAmountChange);
        let newLeadersCount =
          value?.agents +
          value?.godAgents +
          value?.megaAgents +
          value?.superAgents +
          value?.miniAgents;
        let oldLeadersCount =
          value?.oldleaders +
          value?.oldgodLeaders +
          value?.oldmegaLeaders +
          value?.oldsuperLeaders +
          value?.oldminiLeaders;
        let leadersChange = 0;
        if (newLeadersCount === 0 && oldLeadersCount === 0) {
          leadersChange = 0;
        } else if (newLeadersCount === 0 || oldLeadersCount === 0) {
          if (newLeadersCount === 0) {
            leadersChange = ((0 - oldLeadersCount) / oldLeadersCount) * 100;
          }
          if (oldLeadersCount === 0) {
            leadersChange = ((newLeadersCount + 1 - 1) / 1) * 100;
          }
        } else {
          leadersChange =
            ((newLeadersCount - oldLeadersCount) / oldLeadersCount) * 100;
        }

        setLC(leadersChange);
        let dopChange =
          ((value?.totalDopPurchased -
            value?.oldPurchasesAndDopPurchased[0]?.totalDopPurchased) /
            value?.oldPurchasesAndDopPurchased[0]?.totalDopPurchased) *
          100;

        setDPC(dopChange);
        let oldEarningsEth =
          value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
            ? value?.oldPurchasedAndEarnings[0]?.totalLeaderEarnings
            : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "ETH"
                ? value?.oldPurchasedAndEarnings[2]?.totalLeaderEarnings
                : 0;
        let oldEarningsUsdt =
          value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
            ? value?.oldPurchasedAndEarnings[0]?.totalLeaderEarnings
            : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
                ? value?.oldPurchasedAndEarnings[2]?.totalLeaderEarnings
                : 0;
        let oldEarningsTomi =
          value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
            ? value?.oldPurchasedAndEarnings[0]?.totalLeaderEarnings
            : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
                ? value?.oldPurchasedAndEarnings[2]?.totalLeaderEarnings
                : 0;

        let newEarningsEth =
          value?.purchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
            ? value?.purchasedAndEarnings[0]?.totalLeaderEarnings
            : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
              ? value?.purchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "EETH"
                ? value?.purchasedAndEarnings[2]?.totalLeaderEarnings
                : 0;
        let newEarningsUsdt =
          value?.purchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
            ? value?.purchasedAndEarnings[0]?.totalLeaderEarnings
            : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
                ? value?.purchasedAndEarnings[2]?.totalLeaderEarnings
                : 0;
        let newEarningsTomi =
          value?.purchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
            ? value?.purchasedAndEarnings[0]?.totalLeaderEarnings
            : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
                ? value?.purchasedAndEarnings[2]?.totalLeaderEarnings
                : 0;

        let totalLeaderEarningsOldPrice =
          oldEarningsEth * usdPrice + oldEarningsUsdt;
        let totalLeaderEarningsNewPrice =
          newEarningsEth * usdPrice + newEarningsUsdt;

        let totalLeadersEarningChange = 0;

        if (
          totalLeaderEarningsNewPrice === 0 &&
          totalLeaderEarningsOldPrice === 0
        ) {
          totalLeadersEarningChange = 0;
        } else if (
          totalLeaderEarningsNewPrice === 0 ||
          totalLeaderEarningsOldPrice === 0
        ) {
          if (totalLeaderEarningsNewPrice === 0) {
            totalLeadersEarningChange =
              ((0 - totalLeaderEarningsOldPrice) /
                totalLeaderEarningsOldPrice) *
              100;
          }
          if (totalLeaderEarningsOldPrice === 0) {
            totalLeadersEarningChange =
              ((totalLeaderEarningsNewPrice + 1 - 1) / 1) * 100;
          }
        } else {
          totalLeadersEarningChange =
            ((totalLeaderEarningsNewPrice - totalLeaderEarningsOldPrice) /
              totalLeaderEarningsOldPrice) *
            100;
        }

        setLEC(totalLeadersEarningChange);
        setgg(value?.leaders);
        setggmini(value?.miniLeaders);
        setactiveleader(value?.activeLeaders);

        setmm(value?.megas);
        setss(value?.supers);
      })
      .catch(function (error) {
        // // console.log("status: ", error?.response);
        if (error?.response?.status == 401) {
          // history.push("/login");
        }

        // console.log(error);
      });
    // }
  };

  // const closeDropdown = () => {
  //   // // console.log("ddddddd")
  //   setShowCalendar(!showcalendar);
  // };
  // const ref = useDetectClickOutside({ onTriggered: closeDropdown });
  // // console.log("ddddddd", showcalendar);

  const [copy, setCopy] = useState(false);
  const textCopiedFun2 = () => {
    setCopy(true);
    setTimeout(() => {
      setCopy(false);
    }, 1000);
  };

  const [hoveredElements, setHoveredElements] = useState({
    icon1: false,
    icon2: false,
    icon3: false,
    icon4: false,
    icon5: false,
    icon6: false,
  });
  const handleMouseEnter = (element) => {
    setHoveredElements({ ...hoveredElements, [element]: true });
    const isMobileView = window.innerWidth < 768;
    if (isMobileView) {
      setTimeout(() => {
        setHoveredElements({ ...hoveredElements, [element]: false });
      }, 5000);
    }
  };
  const handleMouseLeave = (element) => {
    setHoveredElements({ ...hoveredElements, [element]: false });
  };

  const [profitChange, setProfitChange] = useState("0");
  const [buybackChange, setBuybackChange] = useState("0");

  const [tokenInsuredChange, setTokenInsuredChange] = useState("0");
  const [insuredCountChange, setInsuredCountChange] = useState("0");
  const [statsData, setStatsData] = useState({});
  const [subscriptionRevenue, setSubscriptionRevenue] = useState("");
  const [subscriptionRevenueUsd, setSubscriptionRevenueUsd] = useState("");
  const [totalLeadersSubscription, setTotalLeadersSubscription] = useState("");
  const [totalUsersSubscription, setTotalUsersSubscription] = useState("");
  const [revenueLeadersSubscription, setRevenueLeadersSubscription] =
    useState("");
  const [revenueUsersSubscription, setRevenueUsersSubscription] = useState("");

  const [gemsLockedStakingChange, setGemsLockedStakingChange] = useState("0");
  const [premiumLeadersStakingChange, setPremiumLeadersStakingChange] =
    useState("0");
  const [goldenUsersStakingChange, setGoldenUsersStakingChange] = useState("0");

  const [gemsLockedSubscriptionChange, setGemsLockedSubscriptionChange] =
    useState("0");
  const [
    premiumLeadersSubscriptionChange,
    setPremiumLeadersSubscriptionChange,
  ] = useState("0");
  const [goldenUsersSubscriptionChange, setGoldenUsersSubscriptionChange] =
    useState("0");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    localStorage.setItem("project", project);

    project && firstTimeData();
  }, [project]);

  useEffect(() => {
    formatDates("1");
  }, []);

  const getStatsData = () => {
    var config = {
      method: "get",
      url: `${Api_Url}/users/platform-stats?privateSale=${project}`,
      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    let dynamicQuery = config.url;

    if (startDate && startDate != null) {
      dynamicQuery += `&startDate=${startDate}&endDate=${endDate}`;
    }
    if (round) {
      dynamicQuery += `&round=${round}`;
    }
    config.url = dynamicQuery;

    axios(config)
      .then(function (response) {
        const resData = response?.data?.data?.data;
        setStatsData(resData);
        let subsrev = 0;
        let oldsubsrev = 0;

        let subrevusd = 0;
        let leaderTotalCount = 0;
        let oldLeaderTotalCount = 0;

        let userTotalCount = 0;
        let oldUserTotalCount = 0;

        let leaderRev = 0;
        let userRev = 0;

        if (resData?.premiumSubscription?.length > 0) {
          resData?.premiumSubscription.forEach((item) => {
            subsrev += item?.amountInvested;
            subrevusd += item?.amountInvestedUsd;

            if (item._id === "leader") {
              // leaderTotalCount = item?.totalCount;
              leaderRev = item?.amountInvested;
            } else if (item._id === "user") {
              // userTotalCount = item?.totalCount;
              userRev = item?.amountInvested;
            }
          });
        }
        if (resData?.oldPremiumSubscription) {
          if (resData?.oldPremiumSubscription?.length > 0) {
            resData?.oldPremiumSubscription.forEach((item) => {
              oldsubsrev += item?.amountInvested;
            });
          }
        }

        if (resData?.premiumSubscriberCount?.length > 0) {
          resData?.premiumSubscriberCount.forEach((item) => {
            if (item._id === "leader") {
              leaderTotalCount = item?.currentSubscriberCount;
            } else if (item._id === "user") {
              userTotalCount = item?.currentSubscriberCount;
            }
          });
        }
        if (resData?.oldPremiumSubscriberCount) {
          if (resData?.oldPremiumSubscriberCount?.length > 0) {
            resData?.oldPremiumSubscriberCount.forEach((item) => {
              if (item._id === "leader") {
                oldLeaderTotalCount = item?.currentSubscriberCount;
              } else if (item._id === "user") {
                oldUserTotalCount = item?.currentSubscriberCount;
              }
            });
          }
        }

        setSubscriptionRevenue(subsrev);
        setSubscriptionRevenueUsd(subrevusd);
        setTotalLeadersSubscription(leaderTotalCount);
        setTotalUsersSubscription(userTotalCount);
        setRevenueLeadersSubscription(leaderRev);
        setRevenueUsersSubscription(userRev);

        const oldGemsStake =
          resData?.oldTotalStakedCount &&
            resData?.oldTotalStakedCount.length > 0
            ? resData?.oldTotalStakedCount?.totalStakedTokens
            : 0;
        const newGemsStake = resData?.totalGemsStaked;
        let gemsStakeChangeTemp = 0;
        if (newGemsStake === 0 && oldGemsStake === 0) {
          gemsStakeChangeTemp = 0;
        } else if (newGemsStake === 0 || oldGemsStake === 0) {
          if (newGemsStake === 0) {
            gemsStakeChangeTemp = ((0 - oldGemsStake) / oldGemsStake) * 100;
          }
          if (oldGemsStake === 0) {
            gemsStakeChangeTemp = ((newGemsStake + 1 - 1) / 1) * 100;
          }
        } else {
          gemsStakeChangeTemp =
            ((newGemsStake - oldGemsStake) / oldGemsStake) * 100;
        }
        setGemsLockedStakingChange(gemsStakeChangeTemp);

        const oldPremLeadersStake =
          resData?.oldPremiumLeadersCount &&
            resData?.oldPremiumLeadersCount.length > 0
            ? resData?.oldPremiumLeadersCount?.premiumLeadersCount
            : 0;
        const newPremLeadersStake = resData?.premiumLeadersCount;
        let premLeadersStakeChangeTemp = 0;
        if (newPremLeadersStake === 0 && oldPremLeadersStake === 0) {
          premLeadersStakeChangeTemp = 0;
        } else if (newPremLeadersStake === 0 || oldPremLeadersStake === 0) {
          if (newPremLeadersStake === 0) {
            premLeadersStakeChangeTemp =
              ((0 - oldPremLeadersStake) / oldPremLeadersStake) * 100;
          }
          if (oldPremLeadersStake === 0) {
            premLeadersStakeChangeTemp =
              ((newPremLeadersStake + 1 - 1) / 1) * 100;
          }
        } else {
          premLeadersStakeChangeTemp =
            ((newPremLeadersStake - oldPremLeadersStake) /
              oldPremLeadersStake) *
            100;
        }
        setPremiumLeadersStakingChange(premLeadersStakeChangeTemp);

        const oldGoldenUsersStake =
          resData?.oldGoldenUser && resData?.oldGoldenUser.length > 0
            ? resData?.oldGoldenUser?.goldenUserCount
            : 0;
        const newGoldenUsersStake = resData?.goldenUserCount;
        let goldenUsersStakeChangeTemp = 0;
        if (newGoldenUsersStake === 0 && oldGoldenUsersStake === 0) {
          goldenUsersStakeChangeTemp = 0;
        } else if (newGoldenUsersStake === 0 || oldGoldenUsersStake === 0) {
          if (newGoldenUsersStake === 0) {
            goldenUsersStakeChangeTemp =
              ((0 - oldGoldenUsersStake) / oldGoldenUsersStake) * 100;
          }
          if (oldGoldenUsersStake === 0) {
            goldenUsersStakeChangeTemp =
              ((newGoldenUsersStake + 1 - 1) / 1) * 100;
          }
        } else {
          goldenUsersStakeChangeTemp =
            ((newGoldenUsersStake - oldGoldenUsersStake) /
              oldGoldenUsersStake) *
            100;
        }
        setGoldenUsersStakingChange(goldenUsersStakeChangeTemp);

        const oldTotalRevSubs = oldsubsrev;
        const newTotalRevSubs = subsrev;

        let totalRevSubsChangeTemp = 0;
        if (newTotalRevSubs === 0 && oldTotalRevSubs === 0) {
          totalRevSubsChangeTemp = 0;
        } else if (newTotalRevSubs === 0 || oldTotalRevSubs === 0) {
          if (newTotalRevSubs === 0) {
            totalRevSubsChangeTemp =
              ((0 - oldTotalRevSubs) / oldTotalRevSubs) * 100;
          }
          if (oldTotalRevSubs === 0) {
            totalRevSubsChangeTemp = ((newTotalRevSubs + 1 - 1) / 1) * 100;
          }
        } else {
          totalRevSubsChangeTemp =
            ((newTotalRevSubs - oldTotalRevSubs) / oldTotalRevSubs) * 100;
        }
        setGemsLockedSubscriptionChange(totalRevSubsChangeTemp);

        const oldLeaderCountSubs = oldLeaderTotalCount;
        const newLeaderCountSubs = leaderTotalCount;
        let totalLeaderSubsChangeTemp = 0;
        if (newLeaderCountSubs === 0 && oldLeaderCountSubs === 0) {
          totalLeaderSubsChangeTemp = 0;
        } else if (newLeaderCountSubs === 0 || oldLeaderCountSubs === 0) {
          if (newLeaderCountSubs === 0) {
            totalLeaderSubsChangeTemp =
              ((0 - oldLeaderCountSubs) / oldLeaderCountSubs) * 100;
          }
          if (oldLeaderCountSubs === 0) {
            totalLeaderSubsChangeTemp =
              ((newLeaderCountSubs + 1 - 1) / 1) * 100;
          }
        } else {
          totalLeaderSubsChangeTemp =
            ((newLeaderCountSubs - oldLeaderCountSubs) / oldLeaderCountSubs) *
            100;
        }
        setPremiumLeadersSubscriptionChange(totalLeaderSubsChangeTemp);

        const olduserCountSubs = oldUserTotalCount;
        const newuserCountSubs = userTotalCount;
        let totaluserSubsChangeTemp = 0;
        if (newuserCountSubs === 0 && olduserCountSubs === 0) {
          totaluserSubsChangeTemp = 0;
        } else if (newuserCountSubs === 0 || olduserCountSubs === 0) {
          if (newuserCountSubs === 0) {
            totaluserSubsChangeTemp =
              ((0 - olduserCountSubs) / olduserCountSubs) * 100;
          }
          if (olduserCountSubs === 0) {
            totaluserSubsChangeTemp = ((newuserCountSubs + 1 - 1) / 1) * 100;
          }
        } else {
          totaluserSubsChangeTemp =
            ((newuserCountSubs - olduserCountSubs) / olduserCountSubs) * 100;
        }
        setGoldenUsersSubscriptionChange(totaluserSubsChangeTemp);

        const oldProfit = resData?.oldNetProfitDollars;
        const newProfit = resData?.netProfitDollars;
        let profitChangeTemp = 0;
        if (newProfit === 0 && oldProfit === 0) {
          profitChangeTemp = 0;
        } else if (newProfit === 0 || oldProfit === 0) {
          if (newProfit === 0) {
            profitChangeTemp = ((0 - oldProfit) / oldProfit) * 100;
          }
          if (oldProfit === 0) {
            profitChangeTemp = ((newProfit + 1 - 1) / 1) * 100;
          }
        } else {
          profitChangeTemp = ((newProfit - oldProfit) / oldProfit) * 100;
        }
        setProfitChange(profitChangeTemp);

        let oldBuyback = 0;
        if (resData?.oldBuyBack?.length > 0) {
          oldBuyback =
            resData?.oldBuyBack[0]?.totalEth * usdPrice +
            resData?.oldBuyBack[0]?.totalUsdt +
            resData?.oldBuyBack[0]?.totalUsdc;
        }
        let newBuyback = 0;
        if (resData?.buyBack?.length > 0) {
          newBuyback =
            resData?.buyBack[0]?.totalEth * usdPrice +
            resData?.buyBack[0]?.totalUsdt +
            resData?.buyBack[0]?.totalUsdc;
        }

        let buyBackChangeTemp = 0;
        if (newBuyback === 0 && oldBuyback === 0) {
          buyBackChangeTemp = 0;
        } else if (newBuyback === 0 || oldBuyback === 0) {
          if (newBuyback === 0) {
            buyBackChangeTemp = ((0 - oldBuyback) / oldBuyback) * 100;
          }
          if (oldBuyback === 0) {
            buyBackChangeTemp = ((newBuyback + 1 - 1) / 1) * 100;
          }
        } else {
          buyBackChangeTemp = ((newBuyback - oldBuyback) / oldBuyback) * 100;
        }
        setBuybackChange(buyBackChangeTemp);

        let oldTokenInsured = 0;
        let tokenInsured = 0;

        if (resData?.oldTokenInsured?.length > 0) {
          oldTokenInsured = resData?.oldTokenInsured[0]?.totalSaleConverted;
        }
        if (resData?.tokenInsured?.length > 0) {
          tokenInsured = resData?.tokenInsured[0]?.totalSaleConverted;
        }

        let tokenInsuredChangeTemp = 0;
        if (tokenInsured === 0 && oldTokenInsured === 0) {
          tokenInsuredChangeTemp = 0;
        } else if (tokenInsured === 0 || oldTokenInsured === 0) {
          if (tokenInsured === 0) {
            tokenInsuredChangeTemp =
              ((0 - oldTokenInsured) / oldTokenInsured) * 100;
          }
          if (oldTokenInsured === 0) {
            tokenInsuredChangeTemp = ((tokenInsured + 1 - 1) / 1) * 100;
          }
        } else {
          tokenInsuredChangeTemp =
            ((tokenInsured - oldTokenInsured) / oldTokenInsured) * 100;
        }
        setTokenInsuredChange(tokenInsuredChangeTemp);

        const oldInsuredCount = resData?.oldInsuredCount;
        const newInsuredCount = resData?.insuredCount;
        let insuredCountChangeTemp = 0;
        if (newInsuredCount === 0 && oldInsuredCount === 0) {
          insuredCountChangeTemp = 0;
        } else if (newInsuredCount === 0 || oldInsuredCount === 0) {
          if (newInsuredCount === 0) {
            insuredCountChangeTemp =
              ((0 - oldInsuredCount) / oldInsuredCount) * 100;
          }
          if (oldInsuredCount === 0) {
            insuredCountChangeTemp = ((newInsuredCount + 1 - 1) / 1) * 100;
          }
        } else {
          insuredCountChangeTemp =
            ((newInsuredCount - oldInsuredCount) / oldInsuredCount) * 100;
        }
        setInsuredCountChange(insuredCountChangeTemp);

        const goldenUserCountTemp =
          resData?.totalUserStakedGems - resData?.premiumLeadersCount;
        const goldenGemsLockedTemp =
          resData?.totalGemsStaked - resData?.leaderStakedTokenCount;

        dispatch(
          goldenUsers({
            premiumCount: resData?.premiumLeadersCount,
            leadersStakedTokenCount: resData?.leaderStakedTokenCount,
            goldenUsers: goldenUserCountTemp,
            gemsLockedGolden: goldenGemsLockedTemp,
          })
        );
      })
      .catch(function (error) {
        if (error?.response?.status == 401) {
          // localStorage.removeItem("accessToken");
          // history.push("/");
        }
      });
  };

  useEffect(() => {
    if (tok && tok !== null) {
      getStatsData();
      GetChartsDataCalendar();
      GetDashboardData();
    }
  }, [startDate, endDate, round, project]);

  const formatDates = (times) => {
    let date = null;
    let date1 = null;
    if (Array.isArray(times)) {
      let a = new Date(times[0]?.startDate);
      let b = new Date(times[0]?.endDate);
      date = moment(a).format("Y-MM-DDT00:00:00");
      date1 = moment(b).format("Y-MM-DDT23:59:59");
    } else if (times == "1") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 0; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (times == "seven") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 7; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (times == "year") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 365; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (times == "month") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 31; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    }
    setStartDate(date);
    setEndDate(date1);
  };



  const handleItemClick = (imgSrc, text, rounds) => {
    setSelectedItem({ imgSrc, text, rounds });
    setProject(text);
    // localStorage.setItem("project", project);
  };

  function formatTokenValue(tokenValue) {
    if (tokenValue >= 1000000) {
      return (tokenValue / 1000000)?.toFixed(2) + "M";
    } else if (tokenValue >= 1000) {
      return (tokenValue / 1000)?.toFixed(2) + "k";
    } else {
      return tokenValue?.toFixed(2);
    }
  }
  const [totalPurchasedAmount, setTotalPurchasedAmount] = useState(0);
  function calculateValue(totalPurchasedAmount, project) {
    let result;

    if (project === 'SCREX') {
      if (totalPurchasedAmount <= 500000) {
        result = totalPurchasedAmount * 0.73;
      } else {
        const firstPart = 500000 * 0.73;
        const remainingPart = (totalPurchasedAmount - 500000) * 0.63;
        result = firstPart + remainingPart;
      }
    } else {
      result = totalPurchasedAmount * 0.63;
    }

    return parseInt(result.toFixed(2));
  }
  function calculateProjectValue(totalPurchasedAmount, project) {
    const percentage = projectPercentage?.[project] || 0.1;
    let result;

    if (project === 'SCREX') {
      if (totalPurchasedAmount <= 500000) {
        result = 0;
      } else {
        result = (totalPurchasedAmount - 500000) * percentage;
      }
    } else {
      result = totalPurchasedAmount * percentage;
    }

    return parseInt(result.toFixed(2));
  }
  const nft = tokenNftStats?.nftStats?.[0] || {};

const tokens = [
  {
    label: "ETH",
    value:
      parseFloat(adminobj?.totalPurchaseEth || 0) +
      parseFloat(nft?.totalPurchaseEth || 0),
    decimals: 4,
  },
  {
    label: "USDT",
    value:
      parseFloat(adminobj?.totalPurchaseUsdt || 0) +
      parseFloat(nft?.totalPurchaseUsdt || 0),
    decimals: 2,
  },
  {
    label: "USDC",
    value:
      parseFloat(adminobj?.totalPurchaseUsdc || 0) +
      parseFloat(nft?.totalPurchaseUsdc || 0),
    decimals: 2,
  },
  {
    label: "DOP",
    value:
      parseFloat(adminobj?.totalPurchaseDopToken || 0) +
      parseFloat(nft?.totalPurchaseDopToken || 0),
    decimals: 2,
  },
  {
    label: "WBTC",
    value:
      parseFloat(adminobj?.totalPurchaseWbtc || 0) +
      parseFloat(nft?.totalPurchaseWbtc || 0),
    decimals: 6,
  },
  {
    label: "PEPE",
    value:
      parseFloat(adminobj?.totalPurchasePepe || 0) +
      parseFloat(nft?.totalPurchasePepe || 0),
    decimals: 2,
  },
  {
    label: "LINK",
    value:
      parseFloat(adminobj?.totalPurchaseLink || 0) +
      parseFloat(nft?.totalPurchaseLink || 0),
    decimals: 2,
  },
  {
    label: "UNI",
    value:
      parseFloat(adminobj?.totalPurchaseUni || 0) +
      parseFloat(nft?.totalPurchaseUni || 0),
    decimals: 2,
  },
  {
    label: "TOMI",
    value:
      parseFloat(adminobj?.totalPurchaseTomi || 0) +
      parseFloat(nft?.totalPurchaseTomi || 0),
    decimals: 2,
  },
  {
    label: "GEMS",
    value:
      parseFloat(adminobj?.totalPurchaseGems || 0) +
      parseFloat(nft?.totalPurchaseGems || 0),
    decimals: 2,
  },
];

  const leaderTokens = [
    {
      label: "ETH",
      value:
        parseFloat(adminobj?.totalLeaderEarningsEth || 0) +
        parseFloat(nft?.totalLeaderEarningsEth || 0),
      decimals: 4,
    },
    {
      label: "USDT",
      value:
        parseFloat(adminobj?.totalLeaderEarningsUsdt || 0) +
        parseFloat(nft?.totalLeaderEarningsUsdt || 0),
      decimals: 2,
    },
    {
      label: "USDC",
      value:
        parseFloat(adminobj?.totalLeaderEarningsUsdc || 0) +
        parseFloat(nft?.totalLeaderEarningsUsdc || 0),
      decimals: 2,
    },
    {
      label: "DOP",
      value:
        parseFloat(adminobj?.totalLeaderEarningsDopToken || 0) +
        parseFloat(nft?.totalLeaderEarningsDopToken || 0),
      decimals: 2,
    },
    {
      label: "WBTC",
      value:
        parseFloat(adminobj?.totalLeaderEarningsWbtc || 0) +
        parseFloat(nft?.totalLeaderEarningsWbtc || 0),
      decimals: 6,
    },
    {
      label: "PEPE",
      value:
        parseFloat(adminobj?.totalLeaderEarningsPepe || 0) +
        parseFloat(nft?.totalLeaderEarningsPepe || 0),
      decimals: 2,
    },
    {
      label: "LINK",
      value:
        parseFloat(adminobj?.totalLeaderEarningsLink || 0) +
        parseFloat(nft?.totalLeaderEarningsLink || 0),
      decimals: 2,
    },
    {
      label: "UNI",
      value:
        parseFloat(adminobj?.totalLeaderEarningsUni || 0) +
        parseFloat(nft?.totalLeaderEarningsUni || 0),
      decimals: 2,
    },
    {
      label: "TOMI",
      value:
        parseFloat(adminobj?.totalLeaderEarningsTomi || 0) +
        parseFloat(nft?.totalLeaderEarningsTomi || 0),
      decimals: 2,
    },
    {
      label: "GEMS",
      value:
        parseFloat(adminobj?.totalLeaderEarningsGems || 0) +
        parseFloat(nft?.totalLeaderEarningsGems || 0),
      decimals: 2,
    },
  ];
  const buyBack = statsData?.buyBack?.[0] || {};

  const buyBackTokens = [
    {
      label: "ETH",
      value: parseFloat(buyBack?.totalEth || 0),
      decimals: 5,
    },
    {
      label: "USDT",
      value: parseFloat(buyBack?.totalUsdt || 0),
      decimals: 2,
    },
    {
      label: "USDC",
      value: parseFloat(buyBack?.totalUsdc || 0),
      decimals: 2,
    },
    {
      label: "DOP",
      value: parseFloat(buyBack?.totalDopToken || 0),
      decimals: 2,
    },
    {
      label: "WBTC",
      value: parseFloat(buyBack?.totalWbtc || 0),
      decimals: 6,
    },
    {
      label: "PEPE",
      value: parseFloat(buyBack?.totalPepe || 0),
      decimals: 2,
    },
    {
      label: "LINK",
      value: parseFloat(buyBack?.totalLink || 0),
      decimals: 2,
    },
    {
      label: "UNI",
      value: parseFloat(buyBack?.totalUni || 0),
      decimals: 2,
    },
    {
      label: "TOMI",
      value: parseFloat(buyBack?.totalTomi || 0),
      decimals: 2,
    },
    {
      label: "GEMS",
      value: parseFloat(buyBack?.totalGems || 0),
      decimals: 2,
    },
  ];

  const tokensWithValue = tokens.filter(t => t.value > 0);
  const leaderTokensWithValue = leaderTokens.filter(t => t.value > 0);
  const netRevenueTokens = tokens.map(token => ({
    ...token,
    value: token.value * 0.7
  }));

  const netRevenueWithValue = netRevenueTokens.filter(t => t.value > 0);
  const buyBackWithValue = buyBackTokens.filter(t => t.value > 0);

  useEffect(() => {
    const nftStats = tokenNftStats?.nftStats?.[0] || {};

    const total =
      usdPrice *
      ((adminobj?.totalPurchaseEth || 0) + (nftStats?.totalPurchaseEth || 0)) +
      btcPrice *
      ((adminobj?.totalPurchaseWbtc || 0) + (nftStats?.totalPurchaseWbtc || 0)) +
      ((adminobj?.totalPurchaseUsdt || 0) + (nftStats?.totalPurchaseUsdt || 0)) +
      dopPrice *
      ((adminobj?.totalPurchaseDopToken || 0) + (nftStats?.totalPurchaseDopToken || 0)) +
      ((adminobj?.totalPurchaseUsdc || 0) + (nftStats?.totalPurchaseUsdc || 0)) +
      pepePrice *
      ((adminobj?.totalPurchasePepe || 0) + (nftStats?.totalPurchasePepe || 0)) +
      linkPrice *
      ((adminobj?.totalPurchaseLink || 0) + (nftStats?.totalPurchaseLink || 0)) +
      uniPrice *
      ((adminobj?.totalPurchaseUni || 0) + (nftStats?.totalPurchaseUni || 0)) +
      tomiPrice *
      ((adminobj?.totalPurchaseTomi || 0) + (nftStats?.totalPurchaseTomi || 0)) +
      gemsPrice *
      ((adminobj?.totalPurchaseGems || 0) + (nftStats?.totalPurchaseGems || 0));

    setTotalPurchasedAmount(total);
  }, [
    adminobj,
    tokenNftStats,
    usdPrice,
    btcPrice,
    dopPrice,
    pepePrice,
    linkPrice,
    uniPrice,
    tomiPrice,
    gemsPrice,
  ]);
  return (
    <>
      <section className="dashboard">
        <div className="custom-container">
          {user?.role == "mini_agent" ||
            user?.role == "god_agent" ||
            user?.role == "agent" ||
            user?.role == "mega_agent" ||
            user?.role == "super_agent" ? (
            <h3 className="welcomesss">
              Hi {welcome ? welcome : ""} {user ? user?.name : ""} Your code is:
              {copy ? (
                <span className="adadasdasdasdasdasdsad">
                  {" "}
                  {user?.accessCode}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    className=""
                  >
                    <path
                      d="M13 10.5V13.5C13 16 12 17 9.5 17H6.5C4 17 3 16 3 13.5V10.5C3 8 4 7 6.5 7H9.5C12 7 13 8 13 10.5Z"
                      stroke="black"
                      stroke-width="2.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17 6.5V9.5C17 12 16 13 13.5 13H12.7143V10.7857C12.7143 8.28571 11.7143 7.28571 9.21429 7.28571H7V6.5C7 4 8 3 10.5 3H13.5C16 3 17 4 17 6.5Z"
                      stroke="black"
                      stroke-width="2.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              ) : (
                <>
                  {user?.accessCode && (
                    <CopyToClipboard
                      text={user?.accessCode}
                      onCopy={textCopiedFun2}
                    >
                      <span className="adadasdasdasdasdasdsad">
                        {user?.accessCode}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          className=""
                        >
                          <path
                            d="M13 10.5V13.5C13 16 12 17 9.5 17H6.5C4 17 3 16 3 13.5V10.5C3 8 4 7 6.5 7H9.5C12 7 13 8 13 10.5Z"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M17 6.5V9.5C17 12 16 13 13.5 13H12.7143V10.7857C12.7143 8.28571 11.7143 7.28571 9.21429 7.28571H7V6.5C7 4 8 3 10.5 3H13.5C16 3 17 4 17 6.5Z"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                    </CopyToClipboard>
                  )}
                </>
              )}
              {/* <span>
                {user?.accessCode}
                <img
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigator.clipboard.writeText(user?.accessCode);
                  }}
                  src="\assets\copy.svg"
                  alt="img"
                  className="img-fluid ms-2"
                />
              </span> */}
            </h3>
          ) : (
            ""
          )}
          {user?.role == "admin" ? (
            <h3 className="welcomesss">Hi {welcome ? welcome : ""}</h3>
          ) : (
            ""
          )}

          <div className="mainbuttonsss">
            <div className="main-heading m-0">
              <div>
                {/* <p className="selfhead">Premium Projects</p> */}
                <p className="selfhead">Premium Projects</p>
                <h6>Dashboard</h6>
              </div>
            </div>
            <button className="gusvtsvtvtsvxs" onClick={() => setShow1(true)}>
              Add Leader
            </button>
            {user?.role == "admin" ? (
              <div className="parent-twice-custom">
                <div className="dropdown">
                  <button
                    className="btn btn-secondary dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <div className="projectmain">
                      {selectedItem.imgSrc && (
                        <img
                          src={selectedItem.imgSrc}
                          alt="projectimg"
                          className="projectimg"
                          width={24}
                        />
                      )}
                      <p className="projectpara">{selectedItem.text}</p>
                    </div>
                    <img
                      src="/assets/arrow-down.svg"
                      alt="arrow-down"
                      className="img-fluid"
                    />
                  </button>
                  <ul className="dropdown-menu">
                    {/* <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={() => handleItemClick("", "All Projects")}
                      >
                        All Projects
                      </a>
                    </li> */}
                    {PROJECT_MAPPING.map((project) => (
                      <li key={project.value}>
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={() => handleItemClick(project.imageSrc, project.value, project.rounds)}
                        >
                          <div className="projectmain">
                            <img
                              src={project.imageSrc}
                              alt="projectimg"
                              className="projectimg"
                              width={project.width || 24} // Provide a default width if not in the mapping
                            />
                            <p className="projectpara">{project.label}</p>
                          </div>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
                <div class="dropdown">
                  <button
                    class="btn btn-secondary dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {round == "" ? "All Rounds" : "Round " + round}
                    <img
                      src="\assets\arrow-down.svg"
                      alt="img"
                      className="img-fluid"
                    />
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        class="dropdown-item"
                        href="#"
                        onClick={() => {
                          setRound("");
                        }}
                      >
                        All Rounds
                      </a>
                    </li>
                    {totalRound?.map((elem, index) => {
                      return (
                        <li
                          onClick={() => {
                            setRound(elem?.round);
                          }}
                        >
                          <a class="dropdown-item" href="#">
                            Round {elem?.round}
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <div className="custom-tab-bar">
                  <a
                    onClick={() => {
                      setalllset("1");
                      setDataTime("1");
                      formatDates("1");
                    }}
                    className={alllset == "1" ? "active" : "noactive"}
                  >
                    1D
                  </a>
                  <a
                    onClick={() => {
                      setalllset("seven");
                      setDataTime("seven");
                      formatDates("seven");
                    }}
                    className={alllset == "seven" ? "active" : "noactive"}
                  >
                    7D
                  </a>
                  <a
                    onClick={() => {
                      setalllset("month");
                      setDataTime("month");
                      formatDates("month");
                    }}
                    className={alllset == "month" ? "active" : "noactive"}
                  >
                    1M
                  </a>
                  <a
                    onClick={() => {
                      setalllset("year");
                      setDataTime("year");
                      formatDates("year");
                    }}
                    className={alllset == "year" ? "active" : "noactive"}
                  >
                    1Y
                  </a>
                  <a
                    onClick={() => {
                      setalllset("all");
                      setDataTime("");
                      formatDates("");
                    }}
                    className={alllset == "all" ? "active" : "noactive"}
                  >
                    All
                  </a>
                  <a onClick={() => setShowCalendar(!showcalendar)}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                    >
                      <path
                        d="M17.0831 3.56V2C17.0831 1.59 16.7431 1.25 16.3331 1.25C15.9231 1.25 15.5831 1.59 15.5831 2V3.5H9.08312V2C9.08312 1.59 8.74311 1.25 8.33312 1.25C7.92312 1.25 7.58312 1.59 7.58312 2V3.56C4.88312 3.81 3.57311 5.42 3.37311 7.81C3.35311 8.1 3.59311 8.34 3.87311 8.34H20.7931C21.0831 8.34 21.3231 8.09 21.2931 7.81C21.0931 5.42 19.7831 3.81 17.0831 3.56Z"
                        fill="#8C8C8C"
                      />
                      <path
                        d="M20.3331 9.83984H4.33313C3.78313 9.83984 3.33313 10.2898 3.33313 10.8398V16.9998C3.33313 19.9998 4.83313 21.9998 8.33313 21.9998H16.3331C19.8331 21.9998 21.3331 19.9998 21.3331 16.9998V10.8398C21.3331 10.2898 20.8831 9.83984 20.3331 9.83984ZM9.54313 18.2098C9.49313 18.2498 9.44313 18.2998 9.39313 18.3298C9.33313 18.3698 9.27313 18.3998 9.21313 18.4198C9.15313 18.4498 9.09313 18.4698 9.03313 18.4798C8.96313 18.4898 8.90313 18.4998 8.83313 18.4998C8.70313 18.4998 8.57313 18.4698 8.45313 18.4198C8.32313 18.3698 8.22313 18.2998 8.12313 18.2098C7.94313 18.0198 7.83313 17.7598 7.83313 17.4998C7.83313 17.2398 7.94313 16.9798 8.12313 16.7898C8.22313 16.6998 8.32313 16.6298 8.45313 16.5798C8.63313 16.4998 8.83313 16.4798 9.03313 16.5198C9.09313 16.5298 9.15313 16.5498 9.21313 16.5798C9.27313 16.5998 9.33313 16.6298 9.39313 16.6698C9.44313 16.7098 9.49313 16.7498 9.54313 16.7898C9.72313 16.9798 9.83313 17.2398 9.83313 17.4998C9.83313 17.7598 9.72313 18.0198 9.54313 18.2098ZM9.54313 14.7098C9.35313 14.8898 9.09313 14.9998 8.83313 14.9998C8.57313 14.9998 8.31313 14.8898 8.12313 14.7098C7.94313 14.5198 7.83313 14.2598 7.83313 13.9998C7.83313 13.7398 7.94313 13.4798 8.12313 13.2898C8.40313 13.0098 8.84313 12.9198 9.21313 13.0798C9.34313 13.1298 9.45313 13.1998 9.54313 13.2898C9.72313 13.4798 9.83313 13.7398 9.83313 13.9998C9.83313 14.2598 9.72313 14.5198 9.54313 14.7098ZM13.0431 18.2098C12.8531 18.3898 12.5931 18.4998 12.3331 18.4998C12.0731 18.4998 11.8131 18.3898 11.6231 18.2098C11.4431 18.0198 11.3331 17.7598 11.3331 17.4998C11.3331 17.2398 11.4431 16.9798 11.6231 16.7898C11.9931 16.4198 12.6731 16.4198 13.0431 16.7898C13.2231 16.9798 13.3331 17.2398 13.3331 17.4998C13.3331 17.7598 13.2231 18.0198 13.0431 18.2098ZM13.0431 14.7098C12.9931 14.7498 12.9431 14.7898 12.8931 14.8298C12.8331 14.8698 12.7731 14.8998 12.7131 14.9198C12.6531 14.9498 12.5931 14.9698 12.5331 14.9798C12.4631 14.9898 12.4031 14.9998 12.3331 14.9998C12.0731 14.9998 11.8131 14.8898 11.6231 14.7098C11.4431 14.5198 11.3331 14.2598 11.3331 13.9998C11.3331 13.7398 11.4431 13.4798 11.6231 13.2898C11.7131 13.1998 11.8231 13.1298 11.9531 13.0798C12.3231 12.9198 12.7631 13.0098 13.0431 13.2898C13.2231 13.4798 13.3331 13.7398 13.3331 13.9998C13.3331 14.2598 13.2231 14.5198 13.0431 14.7098ZM16.5431 18.2098C16.3531 18.3898 16.0931 18.4998 15.8331 18.4998C15.5731 18.4998 15.3131 18.3898 15.1231 18.2098C14.9431 18.0198 14.8331 17.7598 14.8331 17.4998C14.8331 17.2398 14.9431 16.9798 15.1231 16.7898C15.4931 16.4198 16.1731 16.4198 16.5431 16.7898C16.7231 16.9798 16.8331 17.2398 16.8331 17.4998C16.8331 17.7598 16.7231 18.0198 16.5431 18.2098ZM16.5431 14.7098C16.4931 14.7498 16.4431 14.7898 16.3931 14.8298C16.3331 14.8698 16.2731 14.8998 16.2131 14.9198C16.1531 14.9498 16.0931 14.9698 16.0331 14.9798C15.9631 14.9898 15.8931 14.9998 15.8331 14.9998C15.5731 14.9998 15.3131 14.8898 15.1231 14.7098C14.9431 14.5198 14.8331 14.2598 14.8331 13.9998C14.8331 13.7398 14.9431 13.4798 15.1231 13.2898C15.2231 13.1998 15.3231 13.1298 15.4531 13.0798C15.6331 12.9998 15.8331 12.9798 16.0331 13.0198C16.0931 13.0298 16.1531 13.0498 16.2131 13.0798C16.2731 13.0998 16.3331 13.1298 16.3931 13.1698C16.4431 13.2098 16.4931 13.2498 16.5431 13.2898C16.7231 13.4798 16.8331 13.7398 16.8331 13.9998C16.8331 14.2598 16.7231 14.5198 16.5431 14.7098Z"
                        fill="#8C8C8C"
                      />
                    </svg>
                  </a>
                  {/* {showcalendar && ( */}
                  {showcalendar && (
                    <div className="cal set-custom-calendar-div">
                      <DateRange
                        editableDateInputs={true}
                        onChange={(item) => {
                          // GetChartsDataCalendar([item.selection]);
                          // GetDashboardData([item.selection]);
                          formatDates([item.selection]);
                          if (activeTab == "profile-tab") {
                            GetTopTenLeaders1([item.selection]);
                          } else if (activeTab == "top-three") {
                            GetTopThreeData1([item.selection]);
                          } else {
                            GetTopTenData1([item.selection]);
                          }
                        }}
                        moveRangeOnFirstSelection={false}
                        ranges={state}
                      />
                    </div>
                  )}
                </div>
              </div>
            ) : null}
          </div>

          <div className="bottom-cards bottom-cardsnewstyle">
            <div className="single-card">
              <div className="twice-set-items">
                <img
                  src="\assets\dashboard\noofpurchases.svg"
                  alt="img"
                  className="img-fluid"
                />
                <div className="inner-text">
                  <p>No. of Purchases</p>
                  <h6>
                    {tokenNftStats?.nftStats?.length > 0 || adminobj
                      ? (adminobj?.TotalPurchases || 0) +
                      (tokenNftStats?.nftStats[0]?.TotalPurchases || 0)
                      : 0}{" "}
                    <span className={pc > 0 ? "green-text" : "red-text"}>
                      {pc ? pc.toFixed(1) + "% " : ""}
                    </span>
                  </h6>
                </div>
              </div>
              <div className="bottom-text">
                {/* <p className="uni-text">
                    <span></span>
                    {tokenNftStats
                      ? tokenNftStats?.tokensPurchasesCount?.toFixed(4)
                      : 0}{" "}
                    Token
                  </p> */}
                {/* <p className="uni-text">
                    <span></span>
                    {tokenNftStats
                      ? parseInt(
                          tokenNftStats?.nftPurchasesCount?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    NFT
                  </p> */}
              </div>
            </div>
            {/* { console.log(tokenNftStats, 'tokenNftStats')} */}
            {project === 'MATCHAIN' ?
              <div className="single-card" style={{ overflow: "hidden" }}>
                <div className="twice-set-items">
                  <img
                    src="/assets/incentive-purchased.svg"
                    alt="img"
                    className="img-fluid"
                  />
                  <div className="inner-text">
                    <p>{project} Purchased</p>
                    <h6>
                      {adminobj || tokenNftStats?.nftStats?.length > 0
                        ? parseFloat(tokenNftStats?.nftStats[0]?.totalMatchainPurchased)?.toLocaleString("en-US")
                        : 0}
                      &nbsp;
                      {project}{" "}
                      {/* <span className={dpc > 0 ? "green-text" : "red-text"}>
                      {dpc ? dpc.toFixed(1) + "% " : ""}
                    </span> */}
                    </h6>
                  </div>
                </div>

                <div className="bottom-text">
                  <p className="uni-text">
                    <span></span>
                    {tokenNftStats?.nftStats?.length > 0
                      ? parseFloat(
                        tokenNftStats?.nftStats[0]?.sumQuantityPurchased?.toFixed(4)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    Genesis License
                  </p>
                  <p className="uni-text">
                    <span></span>
                    {tokenNftStats?.nftStats?.length > 0
                      ? parseInt(
                        tokenNftStats?.nftStats[0]?.sumBundlePurchased?.toFixed(
                          2
                        )
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    Mega Genesis License
                  </p>
                </div>
                {/* <div className="bottom-text">
                  <p className="uni-text">
                    <span></span>~
                    {dops ? ((dops?.eth + dops?.us) * dopPrice)?.toFixed(2) : 0}{" "}
                    USD
                  </p>
                </div> */}
              </div>
              :
              <div className="single-card" style={{ overflow: "hidden" }}>
                <div className="twice-set-items">
                  <img
                    src="/assets/incentive-purchased.svg"
                    alt="img"
                    className="img-fluid"
                  />
                  <div className="inner-text">
                    <p>{project} Purchased</p>
                    <h6>
                      {adminobj || tokenNftStats?.nftStats?.length > 0
                        ? parseFloat(
                          (
                            (tokenNftStats?.stats?.length > 0
                              ? tokenNftStats.stats[0]?.totalDopPurchased
                              : 0) +
                            (tokenNftStats?.nftStats?.length > 0
                              ? tokenNftStats.nftStats[0]?.totalDopPurchased
                              : 0)
                          )?.toFixed(2)
                        )?.toLocaleString("en-US")
                        : 0}
                      &nbsp;
                      {project == "INCENTIV"
                        ? "INC"
                        : project == "OLYMPUS"
                          ? "OAI"
                          : project}{" "}
                      <span className={dpc > 0 ? "green-text" : "red-text"}>
                        {dpc ? dpc.toFixed(1) + "% " : ""}
                      </span>
                    </h6>
                  </div>
                </div>

                <div className="bottom-text">
                  <p className="uni-text">
                    <span></span>
                    {tokenNftStats?.stats?.length > 0
                      ? parseFloat(
                        tokenNftStats?.stats[0]?.totalDopPurchased?.toFixed(4)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    Token
                  </p>
                  <p className="uni-text">
                    <span></span>
                    {tokenNftStats?.nftStats?.length > 0
                      ? parseInt(
                        tokenNftStats?.nftStats[0]?.totalDopPurchased?.toFixed(
                          2
                        )
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    NFT
                  </p>
                </div>
                {/* <div className="bottom-text">
                  <p className="uni-text">
                    <span></span>~
                    {dops ? ((dops?.eth + dops?.us) * dopPrice)?.toFixed(2) : 0}{" "}
                    USD
                  </p>
                </div> */}
              </div>
            }
            <div className="single-card">
              <div className="twice-set-items">
                <img
                  src="\assets\dashboard\purchasedamount.svg"
                  alt="img"
                  className="img-fluid"
                />
                <div className="inner-text">
                  <p>Purchased Amount</p>
                  {usdPrice ? (
                    <h6 className="datahead">
                      {/* {console.log(usdPrice,btcPrice,dopPrice,pepePrice, linkPrice,uniPrice,tomiPrice,gemsPrice,'dopPricedopPricedopPrice' )} */}
                      {adminobj || tokenNftStats?.nftStats?.length > 0
                        ? "~$" +
                        parseInt(
                          (
                            usdPrice *
                            ((adminobj?.totalPurchaseEth || 0) +
                              (tokenNftStats?.nftStats[0]
                                ?.totalPurchaseEth || 0)) +
                            btcPrice *
                            ((adminobj?.totalPurchaseWbtc || 0) +
                              (tokenNftStats?.nftStats[0]
                                ?.totalPurchaseWbtc || 0)) +
                            ((adminobj?.totalPurchaseUsdt || 0) +
                              (tokenNftStats?.nftStats[0]
                                ?.totalPurchaseUsdt || 0)) +
                            dopPrice *
                            ((adminobj?.totalPurchaseDopToken || 0) +
                              (tokenNftStats?.nftStats[0]
                                ?.totalPurchaseDopToken || 0)) +
                            ((adminobj?.totalPurchaseUsdc || 0) +
                              (tokenNftStats?.nftStats[0]
                                ?.totalPurchaseUsdc || 0)) +
                            pepePrice *
                            ((adminobj?.totalPurchasePepe || 0) +
                              (tokenNftStats?.nftStats[0]
                                ?.totalPurchasePepe || 0)) +
                            linkPrice *
                            ((adminobj?.totalPurchaseLink || 0) +
                              (tokenNftStats?.nftStats[0]
                                ?.totalPurchaseLink || 0)) +
                            uniPrice *
                            ((adminobj?.totalPurchaseUni || 0) +
                              (tokenNftStats?.nftStats[0]
                                ?.totalPurchaseUni || 0)) +
                            tomiPrice *
                            ((adminobj?.totalPurchaseTomi || 0) +
                              (tokenNftStats?.nftStats[0]
                                ?.totalPurchaseTomi || 0)) +
                            gemsPrice *
                            ((adminobj?.totalPurchaseGems || 0) +
                              (tokenNftStats?.nftStats[0]
                                ?.totalPurchaseGems || 0))
                          )?.toFixed(2)
                        ).toLocaleString("en-US")
                        : 0}{" "}
                      <span className={pmc > 0 ? "green-text" : "red-text"}>
                        {pmc ? pmc.toFixed(1) + "% " : ""}
                      </span>
                    </h6>
                  ) : (
                    <h6 className="datahead">~$0.00 USD</h6>
                  )}
                </div>
              </div>
           <div className="bottom-text">
  {tokensWithValue.slice(0, 2).map((token) => (
    <p className="uni-text" key={token.label}>
      <span></span>
      {token.value.toFixed(token.decimals)} {token.label}
    </p>
  ))}
</div>

             {tokensWithValue?.length > 2 && <div class="dropdown cardinsidedrop">
                <button
                  class=""
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="7"
                    viewBox="0 0 13 7"
                    fill="none"
                  >
                    <path
                      d="M0.601562 0.5L0.601563 3.0462L6.80156 6.5L6.80156 3.9538L0.601562 0.5Z"
                      fill="#02171D"
                    />
                    <path
                      d="M13 0.5L13 3.0462L6.8 6.5L6.8 3.9538L13 0.5Z"
                      fill="#02171D"
                    />
                  </svg>
                </button>
                <ul className="dropdown-menu newmenu">
  {tokensWithValue.map((token) => (
    <div className="text" key={token.label}>
      <p>{token.label}</p>
      {token.value.toLocaleString("en-US", {
        minimumFractionDigits: token.decimals,
        maximumFractionDigits: token.decimals,
      })}{" "}
      {token.label}
    </div>
  ))}
</ul>

              </div>}
            </div>
            <div className="single-card">
              <div className="twice-set-items">
                <img
                  src="\assets\dashboard\agentearning.svg"
                  alt="img"
                  className="img-fluid"
                />
                <div className="inner-text">
                  <p>Leader's Earnings</p>
                  {/* <h6>~50,000 USD</h6> */}
                  {usdPrice ? (
                    <h6 className="datahead">
                      {adminobj || tokenNftStats?.nftStats?.length > 0
                        ? "~$" +
                        parseFloat(
                          (
                            usdPrice *
                            ((adminobj?.totalLeaderEarningsEth || 0) +
                              (tokenNftStats?.nftStats[0]
                                ?.totalLeaderEarningsEth || 0)) +
                            btcPrice *
                            ((adminobj?.totalLeaderEarningsWbtc || 0) +
                              (tokenNftStats?.nftStats[0]
                                ?.totalLeaderEarningsWbtc || 0)) +
                            ((adminobj?.totalLeaderEarningsUsdt || 0) +
                              (tokenNftStats?.nftStats[0]
                                ?.totalLeaderEarningsUsdt || 0)) +
                            dopPrice *
                            ((adminobj?.totalLeaderEarningsDopToken || 0) +
                              (tokenNftStats?.nftStats[0]
                                ?.totalLeaderEarningsDopToken || 0)) +
                            ((adminobj?.totalLeaderEarningsUsdc || 0) +
                              (tokenNftStats?.nftStats[0]
                                ?.totalLeaderEarningsUsdc || 0)) +
                            pepePrice *
                            ((adminobj?.totalLeaderEarningsPepe || 0) +
                              (tokenNftStats?.nftStats[0]
                                ?.totalLeaderEarningsPepe || 0)) +
                            linkPrice *
                            ((adminobj?.totalLeaderEarningsLink || 0) +
                              (tokenNftStats?.nftStats[0]
                                ?.totalLeaderEarningsLink || 0)) +
                            uniPrice *
                            ((adminobj?.totalLeaderEarningsUni || 0) +
                              (tokenNftStats?.nftStats[0]
                                ?.totalLeaderEarningsUni || 0)) +
                            tomiPrice *
                            ((adminobj?.totalLeaderEarningsTomi || 0) +
                              (tokenNftStats?.nftStats[0]
                                ?.totalLeaderEarningsTomi || 0)) +
                            gemsPrice *
                            ((adminobj?.totalLeaderEarningsGems || 0) +
                              (tokenNftStats?.nftStats[0]
                                ?.totalLeaderEarningsGems || 0))
                          )?.toFixed(2)
                        ).toLocaleString("en-US")
                        : 0}{" "}
                      <span className={lec > 0 ? "green-text" : "red-text"}>
                        {lec ? lec.toFixed(1) + "% " : ""}
                      </span>
                    </h6>
                  ) : (
                    <h6 className="datahead">~$0.00 USD</h6>
                  )}
                </div>
              </div>
              <div className="bottom-text">
  {leaderTokensWithValue.slice(0, 2).map((token) => (
    <p className="uni-text" key={token.label}>
      <span></span>
      {token.value.toFixed(token.decimals)} {token.label}
    </p>
  ))}
</div>

            {leaderTokensWithValue?.length > 2 &&  <div class="dropdown cardinsidedrop">
                <button
                  class=""
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="7"
                    viewBox="0 0 13 7"
                    fill="none"
                  >
                    <path
                      d="M0.601562 0.5L0.601563 3.0462L6.80156 6.5L6.80156 3.9538L0.601562 0.5Z"
                      fill="#02171D"
                    />
                    <path
                      d="M13 0.5L13 3.0462L6.8 6.5L6.8 3.9538L13 0.5Z"
                      fill="#02171D"
                    />
                  </svg>
                </button>
               <ul className="dropdown-menu">
  {leaderTokensWithValue.map((token) => (
    <div className="text" key={token.label}>
      <p>{token.label}</p>
      {token.value.toLocaleString("en-US", {
        minimumFractionDigits: token.decimals,
        maximumFractionDigits: token.decimals,
      })}{" "}
      {token.label}
    </div>
  ))}
</ul>

              </div>}
            </div>
            {user?.role === "admin" ? (
              <>
                <div className="single-card mobile-spec-height">
                  <div className="twice-set-items">
                    <img
                      src="\assets\dashboard\netrevenue.svg"
                      alt="img"
                      className="img-fluid"
                    />
                    <div className="inner-text">
                      <p>Project Net Revenue</p>
                      {usdPrice ? (
                        <h6 className="datahead">
                          {adminobj?.totalPurchaseUsdt ||
                            adminobj?.totalPurchaseEth ||
                            adminobj?.totalPurchaseUsdc ||
                            adminobj?.totalPurchaseWbtc ||
                            adminobj?.totalPurchasePepe ||
                            adminobj?.totalPurchaseLink ||
                            adminobj?.totalPurchaseUni ||
                            adminobj?.totalPurchaseDopToken ||
                            adminobj?.totalPurchaseTomi ||
                            adminobj?.totalPurchaseGems ||
                            tokenNftStats?.nftStats?.length > 0
                            ? "~$" +
                            parseInt(calculateValue(totalPurchasedAmount, project))?.toLocaleString("en-US")
                            : 0}{" "}
                          <span className={lec > 0 ? "green-text" : "red-text"}>
                            {lec ? lec.toFixed(1) + "% " : ""}
                          </span>
                        </h6>
                      ) : (
                        <h6 className="datahead">~$0.00 USD </h6>
                      )}
                    </div>
                  </div>
                  <div className="bottom-text">
                    {netRevenueWithValue.slice(0, 2).map((token) => (
                      <p className="uni-text" key={token.label}>
                        <span></span>
                        {token.value.toFixed(token.decimals)} {token.label}
                      </p>
                    ))}
                  </div>

             {netRevenueWithValue?.length > 2 &&     <div class="dropdown cardinsidedrop">
                    <button
                      class=""
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="7"
                        viewBox="0 0 13 7"
                        fill="none"
                      >
                        <path
                          d="M0.601562 0.5L0.601563 3.0462L6.80156 6.5L6.80156 3.9538L0.601562 0.5Z"
                          fill="#02171D"
                        />
                        <path
                          d="M13 0.5L13 3.0462L6.8 6.5L6.8 3.9538L13 0.5Z"
                          fill="#02171D"
                        />
                      </svg>
                    </button>
                    <ul className="dropdown-menu newmenu">
                      {netRevenueWithValue.map((token) => (
                        <div className="text" key={token.label}>
                          <p>{token.label}</p>
                          {token.value.toLocaleString("en-US", {
                            minimumFractionDigits: token.decimals,
                            maximumFractionDigits: token.decimals,
                          })}{" "}
                          {token.label}
                        </div>
                      ))}
                    </ul>

                  </div>}
                </div>
              </>
            ) : (
              ""
            )}
            <div className="single-card">
              <div className="inner-parent">
                <div className="twice-set-items">
                  <div className="left-img">
                    <img
                      src="\assets\stats\gemsnetprofit.svg"
                      alt="img"
                      className="img-fluid"
                    />
                  </div>
                  <div className="right-stats">
                    <p className="mt-0">Gems Net Revenue</p>
                    <h6>
                      {usdPrice ? (
                        <h6 className="datahead">
                          {adminobj || tokenNftStats?.nftStats?.length > 0
                            ? "~$" +
                            Number(
                              (
                                // === Total Purchase Calculation ===
                                (
                                  totalPurchasedAmount
                                ) *
                                0.27 -

                                // === Leader Earnings Calculation ===
                                (
                                  usdPrice *
                                  ((adminobj?.totalLeaderEarningsEth || 0) +
                                    (tokenNftStats?.nftStats?.[0]?.totalLeaderEarningsEth || 0)) +
                                  btcPrice *
                                  ((adminobj?.totalLeaderEarningsWbtc || 0) +
                                    (tokenNftStats?.nftStats?.[0]?.totalLeaderEarningsWbtc || 0)) +
                                  ((adminobj?.totalLeaderEarningsUsdt || 0) +
                                    (tokenNftStats?.nftStats?.[0]?.totalLeaderEarningsUsdt || 0)) +
                                  dopPrice *
                                  ((adminobj?.totalLeaderEarningsDopToken || 0) +
                                    (tokenNftStats?.nftStats?.[0]?.totalLeaderEarningsDopToken || 0)) +
                                  ((adminobj?.totalLeaderEarningsUsdc || 0) +
                                    (tokenNftStats?.nftStats?.[0]?.totalLeaderEarningsUsdc || 0)) +
                                  pepePrice *
                                  ((adminobj?.totalLeaderEarningsPepe || 0) +
                                    (tokenNftStats?.nftStats?.[0]?.totalLeaderEarningsPepe || 0)) +
                                  linkPrice *
                                  ((adminobj?.totalLeaderEarningsLink || 0) +
                                    (tokenNftStats?.nftStats?.[0]?.totalLeaderEarningsLink || 0)) +
                                  uniPrice *
                                  ((adminobj?.totalLeaderEarningsUni || 0) +
                                    (tokenNftStats?.nftStats?.[0]?.totalLeaderEarningsUni || 0)) +
                                  tomiPrice *
                                  ((adminobj?.totalLeaderEarningsTomi || 0) +
                                    (tokenNftStats?.nftStats?.[0]?.totalLeaderEarningsTomi || 0)) +
                                  gemsPrice *
                                  ((adminobj?.totalLeaderEarningsGems || 0) +
                                    (tokenNftStats?.nftStats?.[0]?.totalLeaderEarningsGems || 0))
                                ) +

                                // === Project Percentage on Total Purchase ===
                                calculateProjectValue(totalPurchasedAmount, project)
                                // (
                                //   totalPurchasedAmount
                                // ) *
                                // (projectPercentage?.[project] || 0.1)
                              ).toFixed(2)
                            ).toLocaleString("en-US")
                            : 0}{" "}
                          {profitChange >= 0 ? (
                            <span className="green-text">
                              +{parseFloat(profitChange)?.toFixed(2)}%
                            </span>
                          ) : (
                            <span className="red-text">
                              {parseFloat(profitChange)?.toFixed(2)}%
                            </span>
                          )}
                        </h6>
                      ) : (
                        <h6 className="datahead">~$0.00 USD </h6>
                      )}
                    </h6>

                  </div>
                </div>
              </div>
            </div>

            <div className="single-card mobile-spec-height noofleaders-card ">
              <div className="twice-set-items">
                <img
                  src="\assets\dashboard\noofagents.svg"
                  alt="img"
                  className="img-fluid"
                />
                <div className="inner-text">
                  <p className="mt-0">Leaders/Active Leaders</p>
                  <div
                    className="twice-textbtn"
                    onClick={() => SetShowtext(!showtext)}
                  >
                    <h6>
                      {totalleader ? totalleader : 0} /{" "}
                      {activeleader ? activeleader : 0}
                      <span
                        className={lc > 0 ? "green-text ms-2" : "red-text ms-2"}
                      >
                        {lc ? lc.toFixed(1) + "% " : ""}
                      </span>
                    </h6>
                    <img
                      src="\assets\arrow-down.svg"
                      alt="img"
                      className={
                        showtext
                          ? "img-fluid arrow-down-icon transform-img d-none displayblockinmobile"
                          : "img-fluid arrow-down-icon d-none displayblockinmobile"
                      }
                    />
                  </div>
                </div>
              </div>
              <div
                className={
                  showtext ? "bottom-text showtext" : "bottom-text hidetext"
                }
              >
                <p className="uni-text">
                  <span></span>
                  {g ? g : 0} God{" "}
                </p>
                <p className="uni-text">
                  <span></span>
                  {m ? m : 0} Mega{" "}
                </p>
                <p className="uni-text">
                  <span></span>
                  {s ? s : 0} Super{" "}
                </p>
                {/* <p className="uni-text">
                      <span></span>
                      {a ? a : 0} Leader{" "}
                    </p>
                    <p className="uni-text">
                      <span></span>
                      {gmini ? gmini : 0} Ambassador{" "}
                    </p> */}
                {/* <p className='uni-text'><span></span>0 Mega </p>
                    <p className='uni-text'><span></span>0 Super </p>
                    <p className='uni-text'><span></span>0 Agent  </p>
                    <p className='uni-text'><span></span>0 God  </p> */}
              </div>

              <div class="dropdown cardinsidedrop">
                <button
                  class=""
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="7"
                    viewBox="0 0 13 7"
                    fill="none"
                  >
                    <path
                      d="M0.601562 0.5L0.601563 3.0462L6.80156 6.5L6.80156 3.9538L0.601562 0.5Z"
                      fill="#02171D"
                    />
                    <path
                      d="M13 0.5L13 3.0462L6.8 6.5L6.8 3.9538L13 0.5Z"
                      fill="#02171D"
                    />
                  </svg>
                </button>
                <ul class="dropdown-menu newmenu">
                  <div className="text">
                    <p>{g ? g : 0} God </p>
                  </div>
                  <div className="text">
                    <p>{m ? m : 0} Mega </p>
                  </div>
                  <div className="text">
                    <p>{s ? s : 0} Super </p>
                  </div>
                  <div className="text">
                    <p>{a ? a : 0} Leader </p>
                  </div>
                  <div className="text">
                    <p>{gmini ? gmini : 0} Ambassador </p>
                  </div>
                </ul>
              </div>
            </div>

            <div className="single-card">
              <div className="inner-parent">
                <div className="twice-set-items">
                  <div className="left-img">
                    <img
                      src="\assets\stats\buyback.svg"
                      alt="img"
                      className="img-fluid"
                    />
                  </div>
                  <div className="right-stats">
                    <p className="mt-0">Buy Backs</p>
                    <h6>
                      {statsData?.buybackCount?.toLocaleString()}
                      {buybackChange >= 0 ? (
                        <span className="green-text">
                          +{parseFloat(buybackChange)?.toFixed(2)}%
                        </span>
                      ) : (
                        <span className="red-text">
                          -{parseFloat(buybackChange)?.toFixed(2)}%
                        </span>
                      )}
                    </h6>
                  </div>
                </div>
              </div>
              <div className="bottom-text">
                {statsData?.buyBack?.length > 0 ? (
                  <p className="uni-text">
                    <span></span>$
                    {(
                      statsData?.buyBack[0]?.totalEth * usdPrice +
                      statsData?.buyBack[0]?.totalUsdt +
                      statsData?.buyBack[0]?.totalUsdc +
                      btcPrice * (statsData?.buyBack[0]?.totalWbtc || 0) +
                      pepePrice * statsData?.buyBack[0]?.totalPepe +
                      linkPrice * statsData?.buyBack[0]?.totalLink +
                      uniPrice * statsData?.buyBack[0]?.totalUni +
                      dopPrice * (statsData?.buyBack[0]?.totalDopToken || 0) +
                      tomiPrice * (statsData?.buyBack[0]?.totalTomi || 0) +
                      gemsPrice * (statsData?.buyBack[0]?.totalGems || 0)
                    )?.toLocaleString()}
                  </p>
                ) : (
                  <p>
                    <span></span>$ 0
                  </p>
                )}
              </div>
             {buyBackWithValue?.length > 0 && <div class="dropdown cardinsidedrop">
                <button
                  class=""
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="7"
                    viewBox="0 0 13 7"
                    fill="none"
                  >
                    <path
                      d="M0.601562 0.5L0.601563 3.0462L6.80156 6.5L6.80156 3.9538L0.601562 0.5Z"
                      fill="#02171D"
                    />
                    <path
                      d="M13 0.5L13 3.0462L6.8 6.5L6.8 3.9538L13 0.5Z"
                      fill="#02171D"
                    />
                  </svg>
                </button>
                <ul className="dropdown-menu">
                  {buyBackWithValue.map((token) => (
                    <div className="text" key={token.label}>
                      <p>{token.label}</p>
                      <h6>
                        {token.value.toLocaleString("en-US", {
                          minimumFractionDigits: token.decimals,
                          maximumFractionDigits: token.decimals,
                        })}{" "}
                        {token.label}
                      </h6>
                    </div>
                  ))}
                </ul>

              </div>}
            </div>
            {/* <div className="single-card">
              <div className="inner-parent">
                <div className="twice-set-items">
                  <div className="left-img">
                    <img
                      src="\assets\stats\purchasedinsurance.svg"
                      alt="img"
                      className="img-fluid"
                    />
                  </div>
                  <div className="right-stats">
                    <p className="mt-0">purchased insurance</p>
                    <h6>
                      {statsData?.insuredCount
                        ? parseInt(statsData?.insuredCount)?.toLocaleString()
                        : 0}

                      {insuredCountChange >= 0 ? (
                        <span className="green-text">
                          +{parseFloat(insuredCountChange)?.toFixed(2)}%
                        </span>
                      ) : (
                        <span className="red-text">
                          -{parseFloat(insuredCountChange)?.toFixed(2)}%
                        </span>
                      )}
                    </h6>
                  </div>
                </div>
              </div>
              <div className="bottom-text">
                <p className="uni-text">
                  <span></span>0 activate
                </p>
                <p className="uni-text">
                  <span></span>0 claim tokens
                </p>
              </div>
            </div>
            <div className="single-card">
              <div className="inner-parent">
                <div className="twice-set-items">
                  <div className="left-img">
                    <img
                      src="\assets\stats\amountinsured.svg"
                      alt="img"
                      className="img-fluid"
                    />
                  </div>
                  <div className="right-stats">
                    <p className="mt-0">Amount Insured</p>
                    <h6>
                      {statsData?.tokenInsured?.length > 0
                        ? parseInt(
                            statsData?.tokenInsured[0]?.dopPurchased
                          )?.toLocaleString()
                        : 0}{" "}
                      {project == "INCENTIV" ? "INC":project == "OLYMPUS" ? "OAI" : project}
                      {tokenInsuredChange >= 0 ? (
                        <span className="green-text">
                          +{parseFloat(tokenInsuredChange)?.toFixed(2)}%
                        </span>
                      ) : (
                        <span className="red-text">
                          -{parseFloat(tokenInsuredChange)?.toFixed(2)}%
                        </span>
                      )}
                    </h6>
                  </div>
                </div>
              </div>
              <div className="bottom-text">
                <p className="uni-text">
                  <span></span>
                  ~$
                  {statsData?.tokenInsured?.length > 0
                    ? parseFloat(
                        statsData?.tokenInsured[0]?.totalSaleConverted?.toFixed(
                          2
                        )
                      )?.toLocaleString()
                    : 0}{" "}
                  USD
                </p>
              </div>
            </div> */}
          </div>
          <h4 className="upper-head-premium">premium (via staking) stats</h4>
          <div className="bottom-cards">
            <div className="single-card">
              <div className="inner-parent">
                <div className="twice-set-items">
                  <div className="left-img">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M11.25 18.25H9C7.9 18.25 7 19.15 7 20.25V20.5H6C5.59 20.5 5.25 20.84 5.25 21.25C5.25 21.66 5.59 22 6 22H18C18.41 22 18.75 21.66 18.75 21.25C18.75 20.84 18.41 20.5 18 20.5H17V20.25C17 19.15 16.1 18.25 15 18.25H12.75V15.96C12.5 15.99 12.25 16 12 16C11.75 16 11.5 15.99 11.25 15.96V18.25Z"
                        fill="#E89735"
                      />
                      <path
                        d="M18.48 11.64C19.14 11.39 19.72 10.98 20.18 10.52C21.11 9.49 21.72 8.26 21.72 6.82C21.72 5.38 20.59 4.25 19.15 4.25H18.59C17.94 2.92 16.58 2 15 2H9.00003C7.42003 2 6.06003 2.92 5.41003 4.25H4.85003C3.41003 4.25 2.28003 5.38 2.28003 6.82C2.28003 8.26 2.89003 9.49 3.82003 10.52C4.28003 10.98 4.86003 11.39 5.52003 11.64C6.56003 14.2 9.06003 16 12 16C14.94 16 17.44 14.2 18.48 11.64ZM14.84 8.45L14.22 9.21C14.12 9.32 14.05 9.54 14.06 9.69L14.12 10.67C14.16 11.27 13.73 11.58 13.17 11.36L12.26 11C12.12 10.95 11.88 10.95 11.74 11L10.83 11.36C10.27 11.58 9.84003 11.27 9.88003 10.67L9.94003 9.69C9.95003 9.54 9.88003 9.32 9.78003 9.21L9.16003 8.45C8.77003 7.99 8.94003 7.48 9.52003 7.33L10.47 7.09C10.62 7.05 10.8 6.91 10.88 6.78L11.41 5.96C11.74 5.45 12.26 5.45 12.59 5.96L13.12 6.78C13.2 6.91 13.38 7.05 13.53 7.09L14.48 7.33C15.06 7.48 15.23 7.99 14.84 8.45Z"
                        fill="#E89735"
                      />
                    </svg>
                  </div>
                  <div className="right-stats">
                    <p className="mt-0">Gems Locked (via Staking)</p>
                    <h6>
                      <h6 className="datahead">
                        {statsData?.totalGemsStaked
                          ? formatTokenValue(statsData?.totalGemsStaked)
                          : 0}{" "}
                        GEMS
                        {gemsLockedStakingChange >= 0 ? (
                          <span className="green-text">
                            +{parseFloat(gemsLockedStakingChange)?.toFixed(2)}%
                          </span>
                        ) : (
                          <span className="red-text">
                            {parseFloat(gemsLockedStakingChange)?.toFixed(2)}%
                          </span>
                        )}
                      </h6>
                    </h6>
                  </div>
                </div>
              </div>
              <div className="bottom-text">
                <p className="uni-text">
                  <span></span>$
                  {statsData?.totalGemsStaked
                    ? parseFloat(
                      parseFloat(
                        statsData?.totalGemsStaked * gemsPrice
                      )?.toFixed(2)
                    )?.toLocaleString()
                    : 0}
                </p>
              </div>
            </div>
            <div className="single-card">
              <div className="inner-parent">
                <div className="twice-set-items">
                  <div className="left-img">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M11.25 18.25H9C7.9 18.25 7 19.15 7 20.25V20.5H6C5.59 20.5 5.25 20.84 5.25 21.25C5.25 21.66 5.59 22 6 22H18C18.41 22 18.75 21.66 18.75 21.25C18.75 20.84 18.41 20.5 18 20.5H17V20.25C17 19.15 16.1 18.25 15 18.25H12.75V15.96C12.5 15.99 12.25 16 12 16C11.75 16 11.5 15.99 11.25 15.96V18.25Z"
                        fill="#E89735"
                      />
                      <path
                        d="M18.48 11.64C19.14 11.39 19.72 10.98 20.18 10.52C21.11 9.49 21.72 8.26 21.72 6.82C21.72 5.38 20.59 4.25 19.15 4.25H18.59C17.94 2.92 16.58 2 15 2H9.00003C7.42003 2 6.06003 2.92 5.41003 4.25H4.85003C3.41003 4.25 2.28003 5.38 2.28003 6.82C2.28003 8.26 2.89003 9.49 3.82003 10.52C4.28003 10.98 4.86003 11.39 5.52003 11.64C6.56003 14.2 9.06003 16 12 16C14.94 16 17.44 14.2 18.48 11.64ZM14.84 8.45L14.22 9.21C14.12 9.32 14.05 9.54 14.06 9.69L14.12 10.67C14.16 11.27 13.73 11.58 13.17 11.36L12.26 11C12.12 10.95 11.88 10.95 11.74 11L10.83 11.36C10.27 11.58 9.84003 11.27 9.88003 10.67L9.94003 9.69C9.95003 9.54 9.88003 9.32 9.78003 9.21L9.16003 8.45C8.77003 7.99 8.94003 7.48 9.52003 7.33L10.47 7.09C10.62 7.05 10.8 6.91 10.88 6.78L11.41 5.96C11.74 5.45 12.26 5.45 12.59 5.96L13.12 6.78C13.2 6.91 13.38 7.05 13.53 7.09L14.48 7.33C15.06 7.48 15.23 7.99 14.84 8.45Z"
                        fill="#E89735"
                      />
                    </svg>
                  </div>
                  <div className="right-stats">
                    <p className="mt-0">Premium Leaders (via Staking)</p>
                    <h6>
                      <h6 className="datahead">
                        {statsData?.premiumLeadersCount
                          ? parseInt(
                            statsData?.premiumLeadersCount
                          )?.toLocaleString()
                          : 0}{" "}
                        {premiumLeadersStakingChange >= 0 ? (
                          <span className="green-text">
                            +
                            {parseFloat(premiumLeadersStakingChange)?.toFixed(
                              2
                            )}
                            %
                          </span>
                        ) : (
                          <span className="red-text">
                            {parseFloat(premiumLeadersStakingChange)?.toFixed(
                              2
                            )}
                            %
                          </span>
                        )}
                      </h6>
                    </h6>
                  </div>
                </div>
              </div>
              <div className="bottom-text">
                <p className="uni-text">
                  <span></span>
                  {statsData?.leaderStakedTokenCount
                    ? parseInt(
                      statsData?.leaderStakedTokenCount
                    )?.toLocaleString()
                    : 0}{" "}
                  GEMS Locked
                </p>
              </div>
            </div>
            <div className="single-card">
              <div className="inner-parent">
                <div className="twice-set-items">
                  <div className="left-img">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M11.25 18.25H9C7.9 18.25 7 19.15 7 20.25V20.5H6C5.59 20.5 5.25 20.84 5.25 21.25C5.25 21.66 5.59 22 6 22H18C18.41 22 18.75 21.66 18.75 21.25C18.75 20.84 18.41 20.5 18 20.5H17V20.25C17 19.15 16.1 18.25 15 18.25H12.75V15.96C12.5 15.99 12.25 16 12 16C11.75 16 11.5 15.99 11.25 15.96V18.25Z"
                        fill="#E89735"
                      />
                      <path
                        d="M18.48 11.64C19.14 11.39 19.72 10.98 20.18 10.52C21.11 9.49 21.72 8.26 21.72 6.82C21.72 5.38 20.59 4.25 19.15 4.25H18.59C17.94 2.92 16.58 2 15 2H9.00003C7.42003 2 6.06003 2.92 5.41003 4.25H4.85003C3.41003 4.25 2.28003 5.38 2.28003 6.82C2.28003 8.26 2.89003 9.49 3.82003 10.52C4.28003 10.98 4.86003 11.39 5.52003 11.64C6.56003 14.2 9.06003 16 12 16C14.94 16 17.44 14.2 18.48 11.64ZM14.84 8.45L14.22 9.21C14.12 9.32 14.05 9.54 14.06 9.69L14.12 10.67C14.16 11.27 13.73 11.58 13.17 11.36L12.26 11C12.12 10.95 11.88 10.95 11.74 11L10.83 11.36C10.27 11.58 9.84003 11.27 9.88003 10.67L9.94003 9.69C9.95003 9.54 9.88003 9.32 9.78003 9.21L9.16003 8.45C8.77003 7.99 8.94003 7.48 9.52003 7.33L10.47 7.09C10.62 7.05 10.8 6.91 10.88 6.78L11.41 5.96C11.74 5.45 12.26 5.45 12.59 5.96L13.12 6.78C13.2 6.91 13.38 7.05 13.53 7.09L14.48 7.33C15.06 7.48 15.23 7.99 14.84 8.45Z"
                        fill="#E89735"
                      />
                    </svg>
                  </div>
                  <div className="right-stats">
                    <p className="mt-0">Golden Users (via Staking)</p>
                    <h6>
                      <h6 className="datahead">
                        {statsData?.goldenUserCount
                          ? parseInt(
                            statsData?.goldenUserCount
                          )?.toLocaleString()
                          : 0}{" "}
                        {goldenUsersStakingChange >= 0 ? (
                          <span className="green-text">
                            +{parseFloat(goldenUsersStakingChange)?.toFixed(2)}%
                          </span>
                        ) : (
                          <span className="red-text">
                            {parseFloat(goldenUsersStakingChange)?.toFixed(2)}%
                          </span>
                        )}
                      </h6>
                    </h6>
                  </div>
                </div>
              </div>
              <div className="bottom-text">
                <p className="uni-text">
                  <span></span>
                  {statsData?.goldenUserTokenCount
                    ? parseInt(
                      statsData?.goldenUserTokenCount
                    )?.toLocaleString()
                    : 0}{" "}
                  GEMS Locked
                </p>
              </div>
            </div>
          </div>
          <h4 className="upper-head-premium">
            premium (via subscription) stats
          </h4>
          <div className="bottom-cards">
            <div className="single-card">
              <div className="inner-parent">
                <div className="twice-set-items">
                  <div className="left-img">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M19 3H5L2 9L12 21L22 9L19 3ZM9.62 8L11.12 5H12.88L14.38 8H9.62ZM11 10V16.68L5.44 10H11ZM13 10H18.56L13 16.68V10ZM19.26 8H16.61L15.11 5H17.76L19.26 8ZM6.24 5H8.89L7.39 8H4.74L6.24 5Z"
                        fill="#E89735"
                      />
                    </svg>
                  </div>
                  <div className="right-stats">
                    <p className="mt-0">Total Revenue (via Subscription)</p>
                    <h6>
                      <h6 className="datahead">
                        {subscriptionRevenue
                          ? formatTokenValue(subscriptionRevenue)
                          : 0}{" "}
                        GEMS{" "}
                        {gemsLockedSubscriptionChange >= 0 ? (
                          <span className="green-text">
                            +
                            {parseFloat(gemsLockedSubscriptionChange)?.toFixed(
                              2
                            )}
                            %
                          </span>
                        ) : (
                          <span className="red-text">
                            {parseFloat(gemsLockedSubscriptionChange)?.toFixed(
                              2
                            )}
                            %
                          </span>
                        )}
                      </h6>
                    </h6>
                  </div>
                </div>
              </div>
              <div className="bottom-text">
                <p className="uni-text">
                  <span></span>$
                  {subscriptionRevenue
                    ? formatTokenValue(subscriptionRevenueUsd)
                    : 0}
                </p>
              </div>
            </div>
            <div className="single-card">
              <div className="inner-parent">
                <div className="twice-set-items">
                  <div className="left-img">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M19 3H5L2 9L12 21L22 9L19 3ZM9.62 8L11.12 5H12.88L14.38 8H9.62ZM11 10V16.68L5.44 10H11ZM13 10H18.56L13 16.68V10ZM19.26 8H16.61L15.11 5H17.76L19.26 8ZM6.24 5H8.89L7.39 8H4.74L6.24 5Z"
                        fill="#E89735"
                      />
                    </svg>
                  </div>
                  <div className="right-stats">
                    <p className="mt-0">Premium Leaders (via Subscription)</p>
                    <h6>
                      <h6 className="datahead">
                        {totalLeadersSubscription
                          ? parseInt(totalLeadersSubscription)?.toLocaleString()
                          : 0}{" "}
                        {premiumLeadersSubscriptionChange >= 0 ? (
                          <span className="green-text">
                            +
                            {parseFloat(
                              premiumLeadersSubscriptionChange
                            )?.toFixed(2)}
                            %
                          </span>
                        ) : (
                          <span className="red-text">
                            {parseFloat(
                              premiumLeadersSubscriptionChange
                            )?.toFixed(2)}
                            %
                          </span>
                        )}
                      </h6>
                    </h6>
                  </div>
                </div>
              </div>
              <div className="bottom-text">
                <p className="uni-text">
                  <span></span>
                  {revenueLeadersSubscription
                    ? formatTokenValue(revenueLeadersSubscription)
                    : 0}{" "}
                  GEMS Paid
                </p>
              </div>
            </div>
            <div className="single-card">
              <div className="inner-parent">
                <div className="twice-set-items">
                  <div className="left-img">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M19 3H5L2 9L12 21L22 9L19 3ZM9.62 8L11.12 5H12.88L14.38 8H9.62ZM11 10V16.68L5.44 10H11ZM13 10H18.56L13 16.68V10ZM19.26 8H16.61L15.11 5H17.76L19.26 8ZM6.24 5H8.89L7.39 8H4.74L6.24 5Z"
                        fill="#E89735"
                      />
                    </svg>
                  </div>
                  <div className="right-stats">
                    <p className="mt-0">Golden Users (via Subscription)</p>
                    <h6>
                      <h6 className="datahead">
                        {totalUsersSubscription
                          ? parseInt(totalUsersSubscription)?.toLocaleString()
                          : 0}{" "}
                        {goldenUsersSubscriptionChange >= 0 ? (
                          <span className="green-text">
                            +
                            {parseFloat(goldenUsersSubscriptionChange)?.toFixed(
                              2
                            )}
                            %
                          </span>
                        ) : (
                          <span className="red-text">
                            {parseFloat(goldenUsersSubscriptionChange)?.toFixed(
                              2
                            )}
                            %
                          </span>
                        )}
                      </h6>
                    </h6>
                  </div>
                </div>
              </div>
              <div className="bottom-text">
                <p className="uni-text">
                  <span></span>
                  {revenueUsersSubscription
                    ? formatTokenValue(revenueUsersSubscription)
                    : 0}{" "}
                  GEMS Paid
                </p>
              </div>
            </div>
          </div>

          {(topThreeLeadersData?.amountInvested ||
            topThreeLeadersData?.totalPurchases) &&
            user?.role != "admin" ? (
            <div className="leader-data">
              <div className="twice-tables-set">
                <section className="datatable">
                  <div className="leader-heading">
                    <h6>Top 3 By Purchases</h6>
                  </div>
                  <div className="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>
                            <div className="parent-tag">
                              No.
                              <div className="filter-btn">
                                <svg
                                  width="9"
                                  height="6"
                                  viewBox="0 0 9 6"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.90908 5.14282H4.09498H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z"
                                    fill="#242627"
                                  />
                                </svg>
                                <svg
                                  width="9"
                                  height="6"
                                  viewBox="0 0 9 6"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.90908 0.857178H4.09498H0.660442C0.072714 0.857178 -0.22115 1.63778 0.195157 2.09537L3.36644 5.58114C3.87458 6.13967 4.70107 6.13967 5.20921 5.58114L6.41528 4.25547L8.38049 2.09537C8.79068 1.63778 8.49681 0.857178 7.90908 0.857178Z"
                                    fill="#242627"
                                  />
                                </svg>
                              </div>
                            </div>
                          </th>
                          <th>
                            <div className="parent-tag">
                              Leader
                              <div className="filter-btn">
                                <svg
                                  width="9"
                                  height="6"
                                  viewBox="0 0 9 6"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.90908 5.14282H4.09498H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z"
                                    fill="#242627"
                                  />
                                </svg>
                                <svg
                                  width="9"
                                  height="6"
                                  viewBox="0 0 9 6"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.90908 0.857178H4.09498H0.660442C0.072714 0.857178 -0.22115 1.63778 0.195157 2.09537L3.36644 5.58114C3.87458 6.13967 4.70107 6.13967 5.20921 5.58114L6.41528 4.25547L8.38049 2.09537C8.79068 1.63778 8.49681 0.857178 7.90908 0.857178Z"
                                    fill="#242627"
                                  />
                                </svg>
                              </div>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {topThreeLeadersData?.amountInvested?.length > 0
                          ? topThreeLeadersData?.amountInvested?.map(
                            (item, index) => {
                              return (
                                <>
                                  <tr>
                                    <td>#{index + 1}</td>
                                    <td>
                                      <div className="twice-text">
                                        <h6>{item?.user[0]?.name}</h6>
                                      </div>
                                    </td>
                                  </tr>
                                </>
                              );
                            }
                          )
                          : null}
                      </tbody>
                    </table>
                  </div>
                </section>
                <section className="datatable">
                  <div className="leader-heading">
                    <h6>Top 3 By Amount</h6>
                  </div>
                  <div className="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>
                            <div className="parent-tag">
                              No.
                              <div className="filter-btn">
                                <svg
                                  width="9"
                                  height="6"
                                  viewBox="0 0 9 6"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.90908 5.14282H4.09498H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z"
                                    fill="#242627"
                                  />
                                </svg>
                                <svg
                                  width="9"
                                  height="6"
                                  viewBox="0 0 9 6"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.90908 0.857178H4.09498H0.660442C0.072714 0.857178 -0.22115 1.63778 0.195157 2.09537L3.36644 5.58114C3.87458 6.13967 4.70107 6.13967 5.20921 5.58114L6.41528 4.25547L8.38049 2.09537C8.79068 1.63778 8.49681 0.857178 7.90908 0.857178Z"
                                    fill="#242627"
                                  />
                                </svg>
                              </div>
                            </div>
                          </th>
                          <th>
                            <div className="parent-tag">
                              Leader
                              <div className="filter-btn">
                                <svg
                                  width="9"
                                  height="6"
                                  viewBox="0 0 9 6"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.90908 5.14282H4.09498H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z"
                                    fill="#242627"
                                  />
                                </svg>
                                <svg
                                  width="9"
                                  height="6"
                                  viewBox="0 0 9 6"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.90908 0.857178H4.09498H0.660442C0.072714 0.857178 -0.22115 1.63778 0.195157 2.09537L3.36644 5.58114C3.87458 6.13967 4.70107 6.13967 5.20921 5.58114L6.41528 4.25547L8.38049 2.09537C8.79068 1.63778 8.49681 0.857178 7.90908 0.857178Z"
                                    fill="#242627"
                                  />
                                </svg>
                              </div>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {topThreeLeadersData?.totalPurchases?.length > 0
                          ? topThreeLeadersData?.totalPurchases?.map(
                            (item, index) => {
                              return (
                                <>
                                  <tr>
                                    <td>#{index + 1}</td>
                                    <td>
                                      <div className="twice-text">
                                        <h6>{item?.user[0]?.name}</h6>
                                      </div>
                                    </td>
                                  </tr>
                                </>
                              );
                            }
                          )
                          : null}
                      </tbody>
                    </table>
                  </div>
                </section>
              </div>
            </div>
          ) : null}

          <div className="twice-charts">
            <div className="main-graph">
              <div className="graphheading">
                <h6 className="main-heading">
                  Top 10 Countries by Number of Purchases
                </h6>
                <a className="seealllink" onClick={() => hitfunctionss(13)}>
                  See All
                </a>
              </div>

              <Countrychart
                chartData={chartsData?.purchasesNumberStats}
                chartType={"purchases"}
                seeAll={false}
              />
            </div>
            <div className="main-graph">
              <div className="graphheading">
                <h6 className="main-heading">
                  Top 10 Countries by Purchased Amount
                </h6>
                <a className="seealllink" onClick={() => hitfunctionss(14)}>
                  See All
                </a>
              </div>
              <Countrychart
                chartData={chartsData?.purchaseAmountStats}
                chartType={"amount"}
                seeAll={false}
              />
            </div>
          </div>

          <DataTable
            btcPrice={btcPrice}
            tomiPrice={tomiPrice}
            pepePrice={pepePrice}
            linkPrice={linkPrice}
            uniPrice={uniPrice}
            dopPrice={dopPrice}
            gemsPrice={gemsPrice}
            setSearch={setSearch}
            setTopLeaderSearch={setTopLeaderSearch}
            user={user}
            getTransactionsData={getTransactionsData}
            usdPrice={usdPrice}
            transactions={transactions}
            setOrderDirection={setOrderDirection}
            setOrderField={setOrderField}
            setActiveTab={setActiveTab}
            activeTab={activeTab}
            topTenLeaders={topTenLeaders}
            topTenData={topTenData}
            topThreeData={topThreeData}
            topTenApiCalled={topTenApiCalled}
            topThreeApiCalled={topThreeApiCalled}
            transactionApiCalled={transactionApiCalled}
            project={project}
          />
        </div>
      </section>

      <Modal
        className="add-mega-modal global-modal-scss"
        show={show1}
        onHide={handleClose1}
        centered
      >
        <Modal.Header closeButton>
          {user?.role === "admin" ? (
            <Modal.Title>Add God Leader</Modal.Title>
          ) : (
            <Modal.Title>Add Leader</Modal.Title>
          )}
          {/* {user?.role === "admin" && <Modal.Title>Add Mega Agents</Modal.Title>}
                    {user?.role === "admin" && <Modal.Title>Add Mega Agents</Modal.Title>} */}
        </Modal.Header>
        <Modal.Body>
          <div className="add-mega-div">
            <div className="option-field">
              <div className="material-textfield">
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Enter Leader’s Name"
                />
                {/* <label>Leader’s Name</label> */}
              </div>
            </div>
            <div className="option-field">
              <div className="material-textfield">
                <input
                  type="text"
                  value={addr}
                  onChange={(e) => setAddr(e.target.value)}
                  placeholder="Enter Leader’s Wallet Address"
                />
                {/* <label>Leader’s Wallet Address</label> */}
              </div>
            </div>
            <div className="option-field">
              <div className="material-textfield">
                <input
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  type="text"
                  placeholder="Enter Leader’s Email Address"
                />
                {/* <label>Leader’s Email Address</label> */}
              </div>
            </div>
            {user?.role !== "admin" && (
              <div className="option-field">
                <div class="dropdown">
                  <button
                    class="btn btn-secondary dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {role === null
                      ? "Type of Leader"
                      : convertToTitleCase(role)}
                  </button>
                  {user?.role === "god_agent" && (
                    <ul class="dropdown-menu">
                      <li onClick={() => setRole("mega_agent")}>
                        <a class="dropdown-item" href="#">
                          Mega Leader
                        </a>
                      </li>
                      <li onClick={() => setRole("super_agent")}>
                        <a class="dropdown-item" href="#">
                          Super Leader
                        </a>
                      </li>
                      <li onClick={() => setRole("agent")}>
                        <a class="dropdown-item" href="#">
                          Leader
                        </a>
                      </li>
                      <li onClick={() => setRole("mini_agent")}>
                        <a class="dropdown-item" href="#">
                          Ambassador
                        </a>
                      </li>
                    </ul>
                  )}
                  {user?.role === "mega_agent" && (
                    <ul class="dropdown-menu">
                      <li onClick={() => setRole("super_agent")}>
                        <a class="dropdown-item" href="#">
                          Super Leader
                        </a>
                      </li>
                      <li onClick={() => setRole("agent")}>
                        <a class="dropdown-item" href="#">
                          Leader
                        </a>
                      </li>
                      <li onClick={() => setRole("mini_agent")}>
                        <a class="dropdown-item" href="#">
                          Ambassador
                        </a>
                      </li>
                    </ul>
                  )}
                  {user?.role === "super_agent" && (
                    <ul class="dropdown-menu">
                      <li onClick={() => setRole("agent")}>
                        <a class="dropdown-item" href="#">
                          Leader
                        </a>
                      </li>
                      <li onClick={() => setRole("mini_agent")}>
                        <a class="dropdown-item" href="#">
                          Ambassador
                        </a>
                      </li>
                    </ul>
                  )}
                  {user?.role === "agent" && (
                    <ul class="dropdown-menu">
                      <li onClick={() => setRole("mini_agent")}>
                        <a class="dropdown-item" href="#">
                          Ambassador
                        </a>
                      </li>
                    </ul>
                  )}
                </div>
              </div>
            )}
          </div>
          <p
            style={{
              color: "red",
              textAlign: "center",
              marginTop: -15,
              marginBottom: 15,
            }}
          >
            {error}
          </p>
          <div className="twice-btn">
            <button
              onClick={() => {
                handleClose1();
                setError("");
              }}
              className="btn-cancel"
            >
              Back
            </button>
            <button
              disabled={loader}
              className="btn-add"
              onClick={() => AddAgent()}
            >
              {loader ? "Adding..." : "Add"}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="add-mega-modal global-modal-scss"
        show={show2}
        onHide={handleClose2}
        centered
      >
        <Modal.Header closeButton>
          {user?.role === "admin" ? (
            <Modal.Title>Add Mega Leaders</Modal.Title>
          ) : (
            <Modal.Title>Add Leaders</Modal.Title>
          )}
        </Modal.Header>
        <Modal.Body>
          <div className="add-mega-div">
            {user?.role === "admin" ? (
              <h6>God Leader has been added</h6>
            ) : (
              <h6>
                {convertToTitleCase(role)}{" "}
                {convertToTitleCase(role) === "Leader"
                  ? "has been added"
                  : convertToTitleCase(role) === "Mega Leader" ||
                    convertToTitleCase(role) === "Ambassador"
                    ? "has been added"
                    : "Leader has been added"}
              </h6>
            )}
          </div>
          <div className="twice-btn">
            <button
              onClick={() => handleClose2()}
              className="btn-add"
              style={{ flex: "auto" }}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Dashboard;